import React from "react";

import { connect } from "react-redux";

import NumberFormat from "react-number-format";
import cookie from "react-cookies";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { isIOS } from "react-device-detect";

import { getLoggedProfile, getListAddress } from "../../actions/sessionAct";
import { getCarDetail } from "../../actions/carDetailAct";

import { init, getCarPrice, getCarCalendar, getPhoneInsurance } from "../../model/car";
import { mapSdk } from "../../model/base";
import { searchInHouse } from "../../model/common";

import { LoadingInline, Loading } from "../common/loading";
import { commonErr } from "../common/errors";
import {
	formatPrice,
	stypes,
	wdType,
	convertToHourText,
	formatSecondTime,
	formatTitleInUrl,
	isEmptyObj,
	convertToWeekDayString,
	moment,
	DType,
	getBookingTimes
} from "../common/common";
import {
	parseWdMinHour,
	checkWdMinHour,
	parseAddressToLocation,
	parseAddressArrayToLocationArray,
	calculateDistance,
	getCookiesRoutes,
	getDurationTime,
	getEndDatewd,
	initMap,
	parseAddressToLocationWithLatLng,
	WDCalendarTemplate,
	WDECalendarTemplate,
} from "../common/wdfunction";
import { MessageErr } from "../common/messagebox";

import Calendar from "./components/calendar"
import CalendarWD from "./components/calendarwd"

import HereAutoComplete from "../common/hereautocomplete";
import WdTypeInfoBox from "../common/wdtypeinfobox";
import LocationDelivery from "./selfdrive/locationdelivery";
import LocationDeliveryPickcerWD from "./withdriver/locationdeliverypickerwd";

import CarBooking from "./carbooking";
import PromoBox from "./promobox";

import InsuranceDetail from "./components/insurancedetail";
import { InsuranceWDDetail } from "./components/insurancedetail";

import Insurance from "./components/insurance";
import { Surcharge } from "./components/infocar";
import PriceSummary from "./components/pricesummary";
import { VerifyPhoneDL, VerifyPhoneBox, VerifyLicense, LicenseForm } from "./components/verifybox";
import { TooltipP } from "../components/tooltip";

import ChangeDriverLicense from "../account/changedriverlicense";
import ChangePhone from "../account/changephone";
import VerifyPhoneOpt from "../account/verifyphoneopt";
import VerifyPhoneOptBreak from "../account/verifyphoneoptbreak";

import {
	IcInstant,
	IcLocationGreen,
	IcStartLocGreen,
	IcEndLocGreen,
	IcCloseOrange,
	IcPlusCGreen,
	IcCompass,
	IcReport,
	IcInfomationTriangle,
	IcQuestion
} from "../common/svg";

var Buffer = require("buffer/").Buffer;

const bookingTimes = getBookingTimes();
// for (var i = 0; i < 1440; i = i + 30) {
// 	const time = i;
// 	const hour = (time - (time % 60)) / 60;
// 	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
// 	const min = time % 60;
// 	const minLabel = min < 10 ? `0${min}` : `${min}`;
// 	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
// }

class BookingSideBar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",

			car: props.detail.info,
			selfPickup: true,
			promoCode: null,
			fromAddress: "",
			fromAddressLat: 0,
			fromAddressLng: 0,
			dateNotAvail: 0,

			showWarningForm: false,
			showVerifyLicense: false,
			showNotifLicense: false,
			isShowBooking: false,
			showDetailIns: false,
			showChangePhone: false,
			showChangeDriverLicense: false,
			showVerifyPhoneOpt: false,

			pickupTimesStr: "",
			returnTimesStr: "",
			minTimesRepeatDetected: "",

			// WD
			locAddress: [{lat: 10.771905, lng: 106.698264}, ""],
			locationArray: [{lat: 10.771905, lng: 106.698264}, ""],
			markerArr: [],
			directionsService: null,
			directionsRenderer: null,
			addressArray: ["Hồ Chí Minh", ""],
			isCityTourMode: true,
			wdOneWay: false,
			isDeliveryByAddressCar: false,
			deliveryAddressChangedFlag: false,
			isSelectHour: false,
			isValidPickupReturnTimes: true,

			deliveryId: props.deliveryId,

			showDateRangePicker: false,
			isCalendar: false,

			isDateBox: false,
		};

		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;

		this.wrapperSelectCD = React.createRef();
		this.map = React.createRef();
	}

	componentDidMount() {
		let { deliveryId } = this.props;

		if (this.props.appInit.err === commonErr.SUCCESS) {
			this.setState({
				minDate: this.props.appInit.data.startDate,
				maxDate: this.props.appInit.data.endDate,
			});
		}

		if (this.isSD) {
			// CHECK IS OWNER
			// NOTE:
			// Set state isOwner, may be missed, because Header call dispath(init()), store change after Bookingsidebar did mount
			// Missed value. Can handle both in componentWillRecieveProps to makesure success
			this.setState({
				isOwner:
					this.props.loggedProfile &&
					this.props.loggedProfile.uid &&
					this.props.loggedProfile.uid === this.props.detail.info.ownerId,
				activeIns: this.props.detail.info.insSupport === 1 ? this.props.detail.info.insBy[0] : 0,
			});
			// GET VALUE OF COOKIE FOR PARAMS TO GETCARPRICE
			// All params: startDate, endDate, promoCode, selfPickup, fromAddress, fromAddressLat, fromAddressLng
			if (
				cookie.load("_mstartts") < moment().add(1, "hours").valueOf() ||
				cookie.load("_mendts") < moment().add(1, "hours").valueOf()
			) {
				cookie.remove("_mstartts", { path: "/" });
				cookie.remove("_mendts", { path: "/" });
			}
			var startDate;
			var endDate;
			var startTime;
			var endTime;
			var promoCode = cookie.load("_promo");

			const cStartTs = cookie.load("_mstartts");
			if (cStartTs) {
				const cStartDate = moment(cStartTs * 1);
				startDate = cStartDate;
				startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}

			const cEndTs = cookie.load("_mendts");
			if (cEndTs) {
				endDate = moment(cEndTs * 1);
				endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}

			var selfPickup = cookie.load("_slfpk") === "false" ? false : true;
			if (selfPickup === true) {
				selfPickup = true;
			} else 
			if (selfPickup === false && this.state.car.deliveryEnable !== 1) {
				selfPickup = true;
			} else {
				selfPickup = false;
			}
			const car = this.props.detail.info;

			var fromAddress = car.locationAddrS;
			var fromAddressLat = car.location.lat;
			var fromAddressLng = car.location.lon;
			var fromAddressType = 1;

			var dAddress = cookie.load("_daddr");

			if (dAddress && !dAddress.type) {
				cookie.remove("_daddr", { path: "/" });
			}

			if (dAddress && car.deliveryLocations && deliveryId) {
				car.deliveryLocations.map((delivery) => {
					if (deliveryId == delivery.deliveryId && dAddress.addr != delivery.name) {
						cookie.remove("_daddr", { path: "/" });
					}
				});
			}

			if (dAddress && dAddress.addr && dAddress.lat && dAddress.lng && dAddress.type) {
				if (dAddress.type === 1) {
					fromAddress = car.locationAddrS;
					fromAddressLat = car.location.lat;
					fromAddressLng = car.location.lon;
					fromAddressType = dAddress.type;
				} else if (dAddress.type === DType.AIRPORT && car.deliveryLocations && !deliveryId) {
					car.deliveryLocations.map((delivery) => {
						if (delivery.name == dAddress.addr && dAddress.lat === delivery.lat && delivery.lon === dAddress.lng) {
							deliveryId = delivery.deliveryId;
							this.setState({
								deliveryId: delivery.deliveryId,
							});
						}
					});
					fromAddress = dAddress.addr;
					fromAddressLat = dAddress.lat;
					fromAddressLng = dAddress.lng;
					fromAddressType = dAddress.type;
				} else if (car.deliveryLocations && deliveryId) {
					car.deliveryLocations.map((delivery) => {
						if (deliveryId == delivery.deliveryId) {
							fromAddress = delivery.name;
							fromAddressLat = delivery.lat;
							fromAddressLng = delivery.lon;
							fromAddressType = DType.AIRPORT;
						}
					});
				} else {
					fromAddress = dAddress.addr;
					fromAddressLat = dAddress.lat;
					fromAddressLng = dAddress.lng;
					fromAddressType = dAddress.type;
				}
			} else if (deliveryId && !dAddress) {
				let dAddress = {};
				if (car.deliveryLocations) {
					for (let i = 0; i < car.deliveryLocations.length; i++) {
						if (deliveryId == car.deliveryLocations[i].deliveryId) {
							fromAddressType = DType.AIRPORT;
							fromAddress = car.deliveryLocations[i].name;
							fromAddressLat = car.deliveryLocations[i].lat;
							fromAddressLng = car.deliveryLocations[i].lon;
							dAddress = {
								addr: fromAddress,
								lat: fromAddressLat,
								lng: fromAddressLng,
								type: fromAddressType,
							};
							break;
						}
					}
				}
				cookie.save("_daddr", JSON.stringify(dAddress), { path: "/" });
			}

			this.getPhoneInsurance();

			// FOR CALENDAR, GETCARPRICE, CHECKTIME
	

			getCarCalendar(car.id, startDate, endDate, "cd").then((resp) => {
				const calendar = resp.data.data;

				// For getcarprice, checktime
				if (!startDate || !endDate) {
					init().then((initResp) => {
						if (initResp.data.data) {
							startDate = moment(initResp.data.data.startTime);
							endDate = moment(initResp.data.data.endTime);

							this.setState({
								startDate,
								endDate,
								startTime: startDate.get("hour") * 60 + startDate.get("minute"),
								endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								selfPickup,
								fromAddress,
								fromAddressLat,
								fromAddressLng,
								fromAddressType,
							});

							if (this.props.detail.info.priceSummary.specialDiscount > 0) {
								this.getCarPriceAndCheckTime({
									selfPickup,
									startDate,
									endDate,
									fromAddress,
									fromAddressLat,
									fromAddressLng,
									promoCode: null,
									calendar,
									deliveryId,
								});
							} else {
								this.getCarPriceAndCheckTime({
									selfPickup,
									startDate,
									endDate,
									fromAddress,
									fromAddressLat,
									fromAddressLng,
									promoCode,
									calendar,
									deliveryId,
								});
							}
						}
					});
				} else {
					startDate = moment(startDate * 1);
					endDate = moment(endDate * 1);

					this.setState({
						startDate: startDate,
						endDate: endDate,
						startTime: startDate.get("hour") * 60 + startDate.get("minute"),
						endTime: endDate.get("hour") * 60 + endDate.get("minute"),
						selfPickup,
						fromAddress,
						fromAddressLat,
						fromAddressLng,
						fromAddressType,
					});

					if (this.props.detail.info.priceSummary && this.props.detail.info.priceSummary.specialDiscount > 0) {
						this.getCarPriceAndCheckTime({
							selfPickup,
							startDate,
							endDate,
							fromAddress,
							fromAddressLat,
							fromAddressLng,
							promoCode: null,
							calendar,
							deliveryId,
						});
					} else {
						this.getCarPriceAndCheckTime({
							selfPickup,
							startDate,
							endDate,
							fromAddress,
							fromAddressLat,
							fromAddressLng,
							promoCode,
							calendar,
							deliveryId,
						});
					}
				}
				// For calendar
				const car = this.props.detail.info;
				const priceMode = this.props.appInit?.data?.priceMode;
				const hiddenFeeMode = priceMode === 2;

				const invalidDays = [];
				const priceSpecifics = [];
				const priceRepeat = [];
				const instantDays = [];
				var i, j;
				if (calendar) {
					this.getPickupAndReturnTimes(calendar);

					if (car.instantEnable) {
						const start =
							car.instantRangeFrom === 0
								? moment(calendar.startDate).startOf("day").valueOf()
								: moment(moment().valueOf() + car.instantRangeFrom * 1000)
										.startOf("day")
										.valueOf();
						const end =
							car.instantRangeTo === 0
								? moment(calendar.endDate).endOf("month").valueOf()
								: moment(moment().valueOf() + car.instantRangeTo * 1000)
										.startOf("day")
										.valueOf();
						for (i = start; i <= end; i += 3600000 * 24) {
							instantDays.push(i);
						}
					}

					if (calendar.unavailsAfter && calendar.unavailsAfter > calendar.unavailsBefore) {
						const start = moment(calendar.startDate).startOf("day").valueOf();
						const end = moment(calendar.endDate).endOf("month").valueOf();
						for (i = start; i < calendar.unavailsBefore * 1000 + moment().startOf("day").valueOf(); i += 3600000 * 24) {
							invalidDays.push({
								date: moment(i),
							});
						}
						const endOfAvailsDay = calendar.unavailsAfter * 1000 + moment().valueOf();
						for (
							i = moment(endOfAvailsDay + 24 * 3600 * 1000)
								.startOf("day")
								.valueOf();
							i <= end;
							i += 3600000 * 24
						) {
							invalidDays.push({
								date: moment(i),
							});
						}
					}

					if (calendar.unavails) {
						for (i = 0; i < calendar.unavails.length; ++i) {
							for (j = calendar.unavails[i].startTime; j <= calendar.unavails[i].endTime; j += 3600000 * 24) {
								invalidDays.push({
									date: moment(j),
								});
							}
						}
					}

					if (calendar.unavailsRepeatWeekday) {
						for (i = 0; i < calendar.unavailsRepeatWeekday.length; ++i) {
							const start = moment();
							const end =
								calendar.unavailsRepeatEndDate > 0 ? moment(calendar.unavailsRepeatEndDate) : moment().add(120, "days");

							for (j = start; j <= end; j = j.add(1, "days")) {
								if (calendar.unavailsRepeatWeekday[i] === 1 && j.isoWeekday() === 7) {
									invalidDays.push({
										date: moment(j),
									});
								} else if (j.isoWeekday() === calendar.unavailsRepeatWeekday[i] - 1) {
									invalidDays.push({
										date: moment(j),
									});
								}
							}
						}
					}

					if (calendar.priceSpecifics) {
						for (i = 0; i < calendar.priceSpecifics.length; ++i) {
							const start = moment(calendar.priceSpecifics[i].startTime).startOf("day").valueOf();
							const end = moment(calendar.priceSpecifics[i].endTime).startOf("day").valueOf();
							for (j = start; j <= end; j += 3600000 * 24) {
								priceSpecifics.push({
									ts: j,
									price: hiddenFeeMode ? calendar.priceSpecifics[i].priceWithFee : calendar.priceSpecifics[i].price,
								});
							}
						}
					}

					for (i = 1; i <= 7; ++i) {
						const weekday = {
							weekday: i,
							price: 0,
						};

						if (calendar.priceRepeat) {
							for (j = 0; j < calendar.priceRepeat.length; ++j) {
								if (i === 7 && calendar.priceRepeat[j].weekday === 1) {
									weekday.price = hiddenFeeMode ? calendar.priceRepeat[j].priceWithFee : calendar.priceRepeat[j].price;
									break;
								} else if (i + 1 === calendar.priceRepeat[j].weekday) {
									weekday.price = hiddenFeeMode ? calendar.priceRepeat[j].priceWithFee : calendar.priceRepeat[j].price;
									break;
								}
							}
						}

						priceRepeat.push(weekday);
					}
				}

				this.setState({
					calendar: calendar,
					priceDaily: hiddenFeeMode ? calendar.priceDailyWithFee : calendar.priceDaily,
					invalidDays: invalidDays,
					priceSpecifics: priceSpecifics,
					priceRepeat: priceRepeat,
					instantDays: instantDays,
					isLimitRepeatPrice: calendar.priceRepeatEndDate > 0,
					priceRepeatEndDate:
						calendar.priceRepeatEndDate > 0 ? calendar.priceRepeatEndDate : moment().add(1, "month").valueOf(),
				});
			});
		} else {
			if (this.props.appInit.err === commonErr.SUCCESS) {
				this.handle(this.props.appInit.data);
				this.setState({
					initData: this.props.appInit.data,
				});
			} else {
				init().then((initResp) => {
					this.handle(initResp.data.data);
					this.setState({
						initData: initResp.data.data,
					});
				});
			}
		}
		document.addEventListener("click", this.handleClick);
		window.addEventListener("resize", this.updateDimensions);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loggedProfile !== this.props.loggedProfile) {
			this.getListAddress();
			this.setState({
				isOwner:
					this.props.loggedProfile &&
					this.props.loggedProfile.uid &&
					this.props.loggedProfile.uid === this.state.car.ownerId,
			});
		}
		if (prevProps.detail.info.id !== this.props.detail.info.id) {
			if (!this.isSD) {
				this.handle(this.props.appInit.data);
				this.setState({
					initData: this.props.appInit.data,
				});
			}
		}
		if (prevProps.appInit.err !== this.props.appInit.err) {
			// Wait for redux init app fulfilled

			if (this.props.appInit.err === commonErr.SUCCESS && this.props.appInit.data) {
				this.setState({
					minDate: this.props.appInit.data.startDate,
					maxDate: this.props.appInit.data.endDate,
				});
			}
		}
	}

	UNSAFE_componentWillMount() {
		// important
		document.removeEventListener("click", this.handleClick);
	}



	handleClick = (event) => {
		// do things here

		if (!this.isSD) {
			const { target } = event;
			if (target !== null && this.wrapperSelectCD.current !== null && !this.wrapperSelectCD.current.contains(target)) {
				const { isSelectHour } = this.state;
				if (isSelectHour) {
					this.setState({
						isSelectHour: false,
					});
				}
			}
		}
	};

	handle = (initData) => {
		let { deliveryId } = this.props;
		this.wdMinHour = parseWdMinHour(initData.wdMinHourCT, initData.wdMinHour, initData.wdMinHourOW);

		var startDate;
		var endDate;
		var addressArray = ["Hồ Chí Minh", ""];
		var isCityTourMode = true;
		var wdOneWay = false;
		const promoCode =
			this.props.detail.info.priceSummary && this.props.detail.info.priceSummary.specialDiscount > 0
				? null
				: cookie.load("_promowd");

		this.setState({
			isOwner:
				this.props.loggedProfile &&
				this.props.loggedProfile.uid &&
				this.props.loggedProfile.uid === this.props.detail.info.ownerId,
			promoCode,
			activeIns: this.props.detail.info.insSupport === 1 ? this.props.detail.info.insBy[0] : 0,
		});

		// check valid cookie before set

		if (!cookie.load("_mstarttswd") || !cookie.load("_mendtswd") || !cookie.load("_mmintswd")) {
			cookie.remove("_mstarttswd", { path: "/" });
			cookie.remove("_mendtswd", { path: "/" });
			cookie.remove("_mmintswd", { path: "/" });
		}

		if (
			cookie.load("_mstarttswd") < moment().add(1, "hours").valueOf() ||
			cookie.load("_mendtswd") < moment().add(1, "hours").valueOf()
		) {
			cookie.remove("_mstarttswd", { path: "/" });
			cookie.remove("_mendtswd", { path: "/" });
			cookie.remove("_mmintswd", { path: "/" });
		}

		var startDate;
		var endDate;
		var selectHour = cookie.load("_mmintswd") * 1;

		const cStartTs = cookie.load("_mstarttswd");
		if (cStartTs) {
			const cStartDate = moment(cStartTs * 1);
			startDate = cStartDate;
		}

		const cEndTs = cookie.load("_mendtswd");
		if (cEndTs) {
			endDate = moment(cEndTs * 1);
		}

		let wdMinHour = isCityTourMode ? initData.wdMinHourCT : wdOneWay ? initData.wdMinHourOW : initData.wdMinHour;
		let durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);

		getCarCalendar(this.props.detail.info.id, startDate, endDate, "cd").then((resp) => {
			const calendar = resp.data.data;
			// For getcarprice, checktime
			if (!startDate || !endDate) {
				startDate = moment(initData.wdStartTime);
				// endDate = moment(initData.wdEndTime);
				endDate = getEndDatewd(durationTimeArr[1], startDate);
				selectHour = durationTimeArr[1];
			} else {
				startDate = moment(startDate * 1);
				// endDate = moment(endDate * 1);
				endDate = selectHour * 1 > 0 ? getEndDatewd(selectHour, startDate) : moment(endDate * 1);
			}

			this.setState({
				startDate: startDate,
				endDate: endDate,
				startTime: startDate.get("hour") * 60 + startDate.get("minute"),
				endTime: endDate.get("hour") * 60 + endDate.get("minute"),
				durationTimeArr: durationTimeArr,
				selectHour: selectHour,
				deliveryId,
			});

			const cRoutes = getCookiesRoutes();
	
			if (cRoutes) {
				const {
					isCityTourMode,
					wdOneWay,
					addressArray,
					locationArray,
					wdLocations,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
					deliveryAddressChangedFlag,
				} = cRoutes;
				const { directionsResponse } = this.props;
				let wdMinHour = isCityTourMode ? initData.wdMinHourCT : wdOneWay ? initData.wdMinHourOW : initData.wdMinHour;
				

				if (addressArray.length === 1) {
					addressArray.push("");
					locationArray.push(undefined);
				}

				this.setState({
					isCityTourMode,
					wdOneWay,
					addressArray,
					locationArray,
					wdLocations,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
					deliveryAddressChangedFlag,
				});

				if (isCityTourMode) {
					// city tour

					if (!wdLocations) {
						wdLocations = `${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString(
							"base64"
						)}`;

						this.setState({
							wdLocations: wdLocations
						})
					
					}

	

					setTimeout(() => {
						initMap(wdOneWay, this.map, [locationArray[0]], false, "", stypes.WD);
					});

					durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);
					selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
					endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

					this.setState({
						locAddress: [locationArray[0]],
						durationTimeArr,
						selectHour,
						endDate,
						endTime: endDate.get("hour") * 60 + endDate.get("minute"),
					});
					this.getCarPriceAndCheckTime({
						startDate,
						endDate,
						fromAddressLat: locationArray[0].lat,
						fromAddressLng: locationArray[0].lng,
						promoCode,
						wdDistance: 0,
						wdLocations: wdLocations.split(",")[0],
						calendar: calendar.wdCalendar,
					});
				} else {
					// across province

					setTimeout(() => {
						initMap(wdOneWay, this.map, locationArray, false, "", stypes.WD);
					});

					durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, wdDistance);
					selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
					endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

					this.setState({
						locAddress: locationArray,
						durationTimeArr,
						selectHour,
						endDate,
						endTime: endDate.get("hour") * 60 + endDate.get("minute"),
					});

					this.getCarPriceAndCheckTime({
						startDate,
						endDate,
						fromAddressLat: locationArray[0].lat,
						fromAddressLng: locationArray[0].lng,
						promoCode,
						wdDistance,
						wdDistanceBackOW,
						wdOneWay,
						wdLocations,
						calendar: calendar.wdCalendar,
						deliveryId,
					});
				}
			} else {
			
				if (!addressArray.includes("")) {
		
					parseAddressArrayToLocationArray(addressArray, (locationArray) => {
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
							const deliveryAddressChangedFlag = false;
							// format wdLocations
							let wdLocations = "";
							for (let i = 0; i < addressArray.length; i++) {
								wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
									"base64"
								)}${i !== addressArray.length - 1 ? "," : ""}`;
							}
							if (addressArray.length === 1) {
								addressArray.push("");
								locationArray.push(undefined);
							}


							this.setState({
								isCityTourMode,
								wdOneWay,
								addressArray,
								locationArray,
								wdLocations,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								deliveryAddressChangedFlag,
							});

							let wdMinHour = isCityTourMode
								? initData.wdMinHourCT
								: wdOneWay
								? initData.wdMinHourOW
								: initData.wdMinHour;

							if (isCityTourMode) {
								// city tour

								setTimeout(() => {
									initMap(wdOneWay, this.map, [locationArray[0]], false, "", stypes.WD);
								});

							

								durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);
								selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
								endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

								this.setState({
									locAddress: [locationArray[0]],
									durationTimeArr,
									selectHour,
									endDate,
									endTime: endDate.get("hour") * 60 + endDate.get("minute"),
									isCityTourMode: true,
									wdOneWay: false
								});

								this.getCarPriceAndCheckTime({
									startDate,
									endDate,
									fromAddressLat: locationArray[0].lat,
									fromAddressLng: locationArray[0].lng,
									promoCode,
									wdDistance: 0,
									wdLocations: wdLocations.split(",")[0],
									calendar: calendar.wdCalendar,
									deliveryId,
								});
							} else {
								// across province

								setTimeout(() => {
									initMap(wdOneWay, this.map, locationArray, false, "", stypes.WD);
								});

								durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, wdDistance);
								selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
								endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

								this.setState({
									locAddress: locationArray,
									durationTimeArr,
									selectHour,
									endDate,
									endTime: endDate.get("hour") * 60 + endDate.get("minute"),
								});
								this.getCarPriceAndCheckTime({
									startDate,
									endDate,
									fromAddressLat: locationArray[0].lat,
									fromAddressLng: locationArray[0].lng,
									promoCode,
									wdDistance,
									wdDistanceBackOW,
									wdOneWay,
									wdLocations,
									calendar: calendar.wdCalendar,
									deliveryId,
								});
							}
						});
					});
				} else {
					addressArray = ["Hồ Chí Minh"];
					isCityTourMode = true;
					wdOneWay = false;
					parseAddressArrayToLocationArray(addressArray, (locationArray) => {
						// getDirectionsResponse(wdOneWay, isCityTourMode ? [locationArray[0]] : locationArray, (directionsResponse) => {
						// 	this.setState({ directionsResponse })
						// })
						calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
							// const deliveryAddressChangedFlag = false;
							// format wdLocations

							setTimeout(() => {
								initMap(wdOneWay, this.map, [locationArray[0]], false, "", stypes.WD);
							});

							let wdLocations = "";
							for (let i = 0; i < addressArray.length; i++) {
								wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
									"base64"
								)}${i !== addressArray.length - 1 ? "," : ""}`;
							}
							if (addressArray.length === 1) {
								addressArray.push("");
								locationArray.push(undefined);
							}

							durationTimeArr = getDurationTime(isCityTourMode, wdMinHour, 0);
							selectHour = durationTimeArr[1] !== selectHour ? selectHour : durationTimeArr[1];
							endDate = selectHour > 0 ? getEndDatewd(selectHour, startDate) : moment(cookie.load("_mendtswd") * 1);

							

							this.setState({
								// wdMinHourDetected,
								isCityTourMode,
								addressArray,
								locationArray,
								wdLocations,
								wdDistance,
								wdDistanceOW,
								wdDistanceBackOW,
								locAddress: [locationArray[0]],
								durationTimeArr,
								selectHour,
								endDate,
								endTime: endDate.get("hour") * 60 + endDate.get("minute"),
							});

							this.getCarPriceAndCheckTime({
								startDate,
								endDate,
								fromAddressLat: locationArray[0].lat,
								fromAddressLng: locationArray[0].lng,
								promoCode,
								wdDistance: 0,
								wdLocations: wdLocations.split(",")[0],
								calendar: calendar.wdCalendar,
								deliveryId,
							});

							// setCookiesRoutes({
							// 	isCityTourMode,
							// 	wdOneWay,
							// 	wdDistance,
							// 	wdDistanceOW,
							// 	wdDistanceBackOW,
							// 	wdLocations,
							// 	deliveryAddressChangedFlag,
							// });

							// const filter = {
							// 	...this.props.carFinding.filter,
							// 	lat: locationArray[0].lat,
							// 	lng: locationArray[0].lng,
							// 	wdLocations: wdLocations.split(",")[0],
							// 	wdDistance: 0,
							// 	wdOneWay,
							// 	wdDistanceBackOW,
							// 	durationTimeArr,
							// 	selectHour,
							// 	endDate,
							// 	endTime: endDate.get("hour") * 60 + endDate.get("minute"),
							// };
							// this.setFilter(filter);
							// this.searchCar(filter);
						});
					});
				
				}
			}

			// For calendar
			const car = this.props.detail.info;
			const invalidDays = [];
			const priceSpecifics = [];
			const priceRepeat = [];
			const instantDays = [];
			var i, j;
			if (calendar) {
				if (car.wdFull && car.wdFull.instantEnable) {
					const start =
						car.wdFull.instantRangeFrom === 0
							? moment(calendar.startDate).startOf("day").valueOf()
							: moment(moment().valueOf() + car.wdFull.instantRangeFrom * 1000)
									.startOf("day")
									.valueOf();
					const end =
						car.wdFull.instantRangeTo === 0
							? moment(calendar.endDate).endOf("month").valueOf()
							: moment(moment().valueOf() + car.wdFull.instantRangeTo * 1000)
									.startOf("day")
									.valueOf();
					for (i = start; i <= end; i += 3600000 * 24) {
						instantDays.push(i);
					}
				}

				if (calendar.unavailsAfter && calendar.unavailsAfter > calendar.unavailsBefore) {
					const start = moment(calendar.startDate).startOf("day").valueOf();
					const end = moment(calendar.endDate).endOf("month").valueOf();
					for (i = start; i < calendar.unavailsBefore * 1000 + moment().startOf("day").valueOf(); i += 3600000 * 24) {
						invalidDays.push({
							date: moment(i),
						});
					}
					const endOfAvailsDay = calendar.unavailsAfter * 1000 + moment().valueOf();
					for (
						i = moment(endOfAvailsDay + 24 * 3600 * 1000)
							.startOf("day")
							.valueOf();
						i <= end;
						i += 3600000 * 24
					) {
						invalidDays.push({
							date: moment(i),
						});
					}
				}

				if (calendar.unavails) {
					for (i = 0; i < calendar.unavails.length; ++i) {
						for (j = calendar.unavails[i].startTime; j <= calendar.unavails[i].endTime; j += 3600000 * 24) {
							invalidDays.push({
								date: moment(j),
							});
						}
					}
				}

				if (calendar.unavailsRepeatWeekday) {
					for (i = 0; i < calendar.unavailsRepeatWeekday.length; ++i) {
						const start = moment();
						const end =
							calendar.unavailsRepeatEndDate > 0 ? moment(calendar.unavailsRepeatEndDate) : moment().add(120, "days");

						for (j = start; j <= end; j = j.add(1, "days")) {
							if (calendar.unavailsRepeatWeekday[i] === 1 && j.isoWeekday() === 7) {
								invalidDays.push({
									date: moment(j),
								});
							} else if (j.isoWeekday() === calendar.unavailsRepeatWeekday[i] - 1) {
								invalidDays.push({
									date: moment(j),
								});
							}
						}
					}
				}

				if (calendar.priceSpecifics) {
					for (i = 0; i < calendar.priceSpecifics.length; ++i) {
						const start = moment(calendar.priceSpecifics[i].startTime).startOf("day").valueOf();
						const end = moment(calendar.priceSpecifics[i].endTime).startOf("day").valueOf();
						for (j = start; j <= end; j += 3600000 * 24) {
							priceSpecifics.push({
								ts: j,
								price: calendar.priceSpecifics[i].price,
							});
						}
					}
				}

				for (i = 1; i <= 7; ++i) {
					const weekday = {
						weekday: i,
						price: 0,
					};

					if (calendar.priceRepeat) {
						for (j = 0; j < calendar.priceRepeat.length; ++j) {
							if (i === 7 && calendar.priceRepeat[j].weekday === 1) {
								weekday.price = calendar.priceRepeat[j].price;
								break;
							} else if (i + 1 === calendar.priceRepeat[j].weekday) {
								weekday.price = calendar.priceRepeat[j].price;
								break;
							}
						}
					}

					priceRepeat.push(weekday);
				}
			}

			this.setState({
				calendar: calendar,
				// priceDaily: calendar.priceDaily,
				invalidDays: invalidDays,
				// priceSpecifics: priceSpecifics,
				// priceRepeat: priceRepeat,
				instantDays: instantDays,
				isLimitRepeatPrice: calendar.priceRepeatEndDate > 0,
				priceRepeatEndDate:
					calendar.priceRepeatEndDate > 0 ? calendar.priceRepeatEndDate : moment().add(1, "month").valueOf(),
			});
		});
	};

	getCarPriceAndCheckTime = (params) => {
		const {
			selfPickup,
			startDate,
			endDate,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			wdDistance,
			wdDistanceBackOW,
			wdOneWay,
			wdLocations,
			calendar,
			deliveryId,
		} = params;
		let { promoCode } = params;
		const car = this.props.detail.info;

		if (this.state.err < commonErr.SUCCESS || !startDate || !endDate) {
			return;
		}

		if (this.isSD) {
			// USE DELIVERY: CUSTOM ADDRESS

			if (!selfPickup && fromAddress != car.locationAddr && fromAddress !== "") {
				if (!fromAddressLat || !fromAddressLng || fromAddressLat === 0 || fromAddressLng === 0) {
					searchInHouse(fromAddress).then((response) => {
						if (response.data.data && response.data.data.locations.length > 0) {
							const loc = response.data.data.locations[0];
							location = { lat: loc.lat, lng: loc.lon };
							const ex = {
								carId: car.id,
								st: startDate,
								et: endDate,
								latD: latLng.lat,
								lngD: latLng.lng,
								promo: promoCode,
								deliveryId: deliveryId,
								stype: this.stype,
								vw: "cd",
							};
							this.getCar(ex, calendar);
						}
					});
				} else {
					const ex = {
						carId: car.id,
						st: startDate,
						et: endDate,
						latD: fromAddressLat,
						lngD: fromAddressLng,
						promo: promoCode,
						deliveryId: deliveryId,
						stype: this.stype,
						vw: "cd",
					};

					this.getCar(ex, calendar);
				}
			}
			// USE DELIVERY: CAR ADDRESS
			else {
				const ex = {
					carId: car.id,
					st: startDate,
					et: endDate,
					lat: 0,
					lng: 0,
					promo: promoCode,
					deliveryId: undefined,
					stype: this.stype,
					vw: "cd",
				};
				this.getCar(ex, calendar);
			}
		} else {
			if (fromAddress === car.locationAddr && fromAddress !== "") {
				if (!fromAddressLat || !fromAddressLng || fromAddressLat === 0 || fromAddressLng === 0)  {
				const ex = {
					carId: car.id,
					st: startDate,
					et: endDate,
					latD: car.location.lat,
					lngD: car.location.lon,
					promo: promoCode,
					deliveryId: deliveryId,
					stype: stypes.WD,
					wdDistance: wdDistance,
					wdDistanceBackOW: wdDistanceBackOW,
					wdLocations: wdLocations,
					wdOneWay: wdOneWay,
					vw: "cd",
				};

				// this.setState({
				// 	addressArray: [car.locationAddrS, ""],
				// });

				this.getCar(ex); }
			
			} else {
				const ex = {
					carId: car.id,
					st: startDate,
					et: endDate,
					latD: fromAddressLat,
					lngD: fromAddressLng,
					promo: promoCode,
					deliveryId: deliveryId,
					stype: stypes.WD,
					wdDistance: wdDistance,
					wdDistanceBackOW: wdDistanceBackOW,
					wdLocations: wdLocations,
					wdOneWay: wdOneWay,
					vw: "cd",
				};

				this.getCar(ex);
			}
		}
	};

	getCar = (ex, calendar) => {
		this.props.dispatch(getCarDetail(ex)).then((response) => {
			const resp = response.action.payload;
			if (resp.data.error === commonErr.SUCCESS && resp.data.data) {
				const totalDays =
					ex.stype === stypes.SD
						? resp.data.data.car.priceSummary.totalDays
						: resp.data.data.car.wdFull.priceSummary.totalHours;
				let promoCode = ex.promo;
				if (resp.data.data.car) {
					this.checkTimes(ex.st, ex.et, totalDays, calendar);
				}

				if (this.isSD) {
					if (resp.data.data.car.priceSummary.promotionDiscount < 0) {
						promoCode = null;
						cookie.remove("_promo", { path: "/" });
					}
				} else {
					// WD
					if (resp.data.data.car.wdFull.priceSummary.promotionDiscountTotal < 0) {
						promoCode = null;
						cookie.remove("_promowd", { path: "/" });
					}
					this.props.setStateFavButtonWD(resp.data.data.car.fav);
					this.setState({
						activeIns: resp.data.data.car.insSupport === 1 ? resp.data.data.car.insBy[0] : 0,
					});
				}

				this.setState({
					err: resp.data.error,
					car: resp.data.data.car,
					dateNotAvail: resp.data.data.dateNotAvail,
					promoCode: promoCode,
					// activeIns: resp.data.data.car.insSupport === 1 ? resp.data.data.car.insBy[0] : 0
				});
			} else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	getProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	getListAddress = () => {
		this.props.dispatch(getListAddress(0, 10));
	};

	getPhoneInsurance = () => {
		getPhoneInsurance().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					phoneInsMic: resp.data.data.zones,
					phoneInsPjico: resp.data.data.zonesPjico,
					phoneInsPVI: resp.data.data.zonesPVI,
					phoneInsVNI: resp.data.data.zonesVNI,
				});
			}
		});
	};

	onUpdateSDDelivery = (address, location, type, isDelivery, deliveryId) => {
	
		const { startDate, endDate, promoCode } = this.state;
		this.setState({
			fromAddress: address,
			fromAddressLat: location.lat,
			fromAddressLng: location.lng,
			selfPickup: isDelivery,
		});

		if (address && location.lat && location.lng) {
			const dAddress = {
				addr: address,
				lat: location.lat,
				lng: location.lng,
				type: type,
			};

			cookie.save("_daddr", JSON.stringify(dAddress), { path: "/" });
		}
		this.setState({ deliveryId: deliveryId });

		this.getCarPriceAndCheckTime({
			selfPickup: isDelivery,
			startDate,
			endDate,
			fromAddress: address,
			fromAddressLat: location.lat,
			fromAddressLng: location.lng,
			promoCode,
			deliveryId: deliveryId,
		});
	};

	onUpdateWDDelivery = (address, location, isDelivery, deliveryId) => {
		this.setState({ isDeliveryByAddressCar: isDelivery, deliveryId: deliveryId });
		const { isCityTourMode, wdOneWay, startDate, endDate, promoCode } = this.state;
		const addressArray = [...this.state.addressArray];
		addressArray[0] = address;
		// parse location
		const locationArray = [...this.state.locationArray];
		locationArray[0] = location;

		if (isCityTourMode) {
			// city tour
		
			this.calculateAndDisplayRoute(wdOneWay, [locationArray[0]], this.state.map);
			const wdLocations = `${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString(
				"base64"
			)}`;
			// const wdLocationsArray = this.state.wdLocations ? this.state.wdLocations.split(",") : ;
			// wdLocationsArray[0] =
			// 	locationArray[0].lat + "-" + locationArray[0].lng + "-" + Buffer.from(addressArray[0]).toString("base64");
			// const wdLocations = wdLocationsArray.join(",");

			this.setState({
				err: commonErr.SUCCESS,
				addressArray,
				locationArray,
				wdLocations,
				deliveryAddressChangedFlag: true,
			});

			// city tour
			let wdMinHourDetected = checkWdMinHour(isCityTourMode, wdOneWay, 0, startDate, endDate, this.wdMinHour);

			this.setState({
				wdMinHourDetected,
				locAddress: [locationArray[0]],
			});

			if (!wdMinHourDetected) {
				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance: 0,
					wdLocations: wdLocations.split(",")[0],
					deliveryId: deliveryId,
				});
			}
		} else {
			// across province
			if (addressArray.includes("")) {
				const locAddress = this.state.locAddress;
				locAddress[0] = locationArray[0];
				this.calculateAndDisplayRoute(wdOneWay, locAddress, this.state.map);
				const wdLocations =
					locationArray[0].lat + "-" + locationArray[0].lng + "-" + Buffer.from(addressArray[0]).toString("base64");
				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance: 0,
					wdLocations,
					deliveryId: deliveryId,
				});

				this.setState({
					addressArray,
					locationArray,
				});
			} else {
				this.calculateAndDisplayRoute(wdOneWay, locationArray, this.state.map);
				calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
					// format wdLocations
					let wdLocations = "";
					for (let i = 0; i < addressArray.length; i++) {
						wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
							"base64"
						)}${i !== addressArray.length - 1 ? "," : ""}`;
					}

					this.setState({
						err: commonErr.SUCCESS,
						addressArray,
						locationArray,
						wdLocations,
						wdDistance,
						wdDistanceOW,
						wdDistanceBackOW,
					});

					// across province
					let wdMinHourDetected = checkWdMinHour(
						isCityTourMode,
						wdOneWay,
						wdDistance,
						startDate,
						endDate,
						this.wdMinHour
					);

					this.setState({
						wdMinHourDetected,
						locAddress: locationArray,
					});

					if (!wdMinHourDetected) {
						this.getCarPriceAndCheckTime({
							startDate,
							endDate,
							fromAddressLat: locationArray[0].lat,
							fromAddressLng: locationArray[0].lng,
							promoCode,
							wdDistance,
							wdDistanceBackOW,
							wdOneWay,
							wdLocations,
							deliveryId: deliveryId,
						});
					}
				});
			}
		}
	};

	toggleLocationDelivery = (show) => {
		this.setState({
			isShowLocationDelivery: !show,
		});
	};

	onDateRangeChange = (picker) => {
		let {
			startTime,
			endTime,
			err,
			errMsg,
			selfPickup,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			promoCode,
			calendar,
			deliveryId,
		} = this.state;
		let { endDate, startDate } = picker;
		
		if (startDate && endDate) {
			startDate = moment(picker.startDate).set({
				hour: (startTime - startTime % 60) / 60,
				minute: startTime % 60,
				second: 0
					});

			endDate = moment(picker.endDate).set({
				hour: (endTime - endTime % 60) / 60,
				minute: endTime % 60,
				second: 0
			});

		

			const hour = Number((endTime - startTime)/60)
			const isSameDay = endDate.format('DD/MM/YYYY') == startDate.format('DD/MM/YYYY');

			if (isSameDay && (0 <= hour && hour < 2)) {
				// this.setState({
				// 	err: commonErr.FAIL,
				// 	errMsg: "Thời gian kết thúc phải lớn hơn thời gian bắt đầu 2 tiếng"
				// });
				return;
			} else if (startDate.valueOf() > endDate.valueOf()) {
				// this.setState({
				// 	err: commonErr.FAIL,
				// 	errMsg: "Thời gian thuê xe không hợp lệ."
				// });
				return;
			} 
	
			// Specical case, not apply change

			// if (startDate && endDate && endDate.valueOf() === startDate.valueOf() && startTime === endTime) {
			// 	// endDate = this.state.endDate;
			// 	return;
			// }

			// if (startDate && endDate && endDate.valueOf() < startDate.valueOf()) {
			// 	// let temp = startDate;
			// 	// startDate = endDate;
			// 	// endDate = temp;
			// 	return;
			// }

			this.getCarPriceAndCheckTime({
				selfPickup,
				startDate,
				endDate,
				fromAddress,
				fromAddressLat,
				fromAddressLng,
				promoCode,
				calendar,
				deliveryId,
			});
	

			this.setState({
				startDate,
				endDate,
				startTime,
				endTime,
				err: commonErr.SUCCESS,
				errMsg: ""
			});
		}
	};

	onStartDateChange = (date) => {
		let {
			err,
			errMsg,
			selfPickup,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			promoCode,
			calendar,
			isCityTourMode,
			wdOneWay,
			wdDistance,
			wdDistanceBackOW,
			wdLocations,
			locationArray,
			selectHour,
			deliveryId,
		} = this.state;

		// let startDate = picker.startDate;
		let startDate = date;
		var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;

		// var startTime = startDate.get("hour") * 60 + startDate.get("minute");
		// var endTime = endDate.get("hour") * 60 + endDate.get("minute");
		// var endTime = endDate.get("hour") * 60 + endDate.get("minute");
		// var hour = this.state.startTime ? (this.state.startTime - this.state.startTime % 60) / 60 : (this.props.carFinding.filter.startTime - this.props.carFinding.filter.startTime % 60) / 60;
		// var minute = this.state.startTime ? this.state.startTime % 60 : this.props.carFinding.filter.startTime % 60;
		
		// startDate.set({
		// 	hour: startDate.get("hour"),
		// 	minute: startDate.get("minute"),
		// 	second: 0,
		// 	milliseconds: 0,
		// });


		if (endDate == startDate && startTime == endTime) {
		    return;
		}

		if (selectHour > 0) {
			endDate = getEndDatewd(selectHour, startDate);
		}

		let locations = isCityTourMode ? wdLocations.split(",")[0] : wdLocations;
		wdDistance = isCityTourMode ? 0 : wdDistance;


		this.getCarPriceAndCheckTime({
			startDate,
			endDate,
			fromAddressLat: locationArray[0].lat,
			fromAddressLng: locationArray[0].lng,
			promoCode,
			wdDistance,
			wdDistanceBackOW,
			wdOneWay,
			wdLocations: locations,
			calendar: calendar.wdCalendar,
			deliveryId,
		});

		this.setState({
			startDate,
			endDate,
			err,
			errMsg,
		});
	};

	onEndDateChange = (date) => {
		let {
			err,
			errMsg,
			startDate,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			promoCode,
			calendar,
			isCityTourMode,
			wdOneWay,
			wdDistance,
			wdDistanceBackOW,
			wdLocations,
			locationArray,
			selectHour,
			deliveryId,
		} = this.state;

		let endDate = date;
		// var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
		var startTime = startDate.get("hour") * 60 + startDate.get("minute");
		var endTime = endDate.get("hour") * 60 + endDate.get("minute");

		// var hour = this.state.startTime ? (this.state.startTime - this.state.startTime % 60) / 60 : (this.props.carFinding.filter.startTime - this.props.carFinding.filter.startTime % 60) / 60;
		// var minute = this.state.startTime ? this.state.startTime % 60 : this.props.carFinding.filter.startTime % 60;

		endDate.set({
			hour: endDate.get("hour"),
			minute: endDate.get("minute"),
			second: 0,
			milliseconds: 0,
		});

		if (endDate == startDate && startTime == endTime) {
			// endDate = startDate.clone().add(1, "days").set({
			// 	hour: endDate.get("hour"),
			// 	minute: endDate.get("minute"),
			// 	second: 0,
			// 	milliseconds: 0
			// });
			return;
		}

		// if (selectHour > 0) {
		// 	endDate = getEndDatewd(selectHour, startDate)
		// }

		let locations = isCityTourMode ? wdLocations.split(",")[0] : wdLocations;
		wdDistance = isCityTourMode ? 0 : wdDistance;

		// endDate = getEndDatewd(selectHour, startDate)
		// endTime = endDate.get('hour') * 60 + endDate.get('minute')

		this.getCarPriceAndCheckTime({
			startDate,
			endDate,
			fromAddressLat: locationArray[0].lat,
			fromAddressLng: locationArray[0].lng,
			promoCode,
			wdDistance,
			wdDistanceBackOW,
			wdOneWay,
			wdLocations: locations,
			calendar: calendar.wdCalendar,
			deliveryId,
		});

		this.setState({
			startDate,
			endDate: endDate,
			startTime,
			endTime,
			err,
			errMsg,
		});
	};

	onStartTimeChange = (time) => {
	
		let {
			startDate,
			endDate,
			startTime,
			endTime,
			err,
			errMsg,
			selfPickup,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			promoCode,
			calendar,
			isCityTourMode,
			wdOneWay,
			wdDistance,
			wdDistanceBackOW,
			wdLocations,
			locationArray,
			selectHour,
			deliveryId,
		} = this.state;
	
		// const hour = (time - (time % 60)) / 60;
		// const min = time % 60;
		startDate = moment(startDate).set({
			hour: (time - (time % 60)) / 60,
			minute: time % 60,
			second: 0,
		});



		// if (endDate && endDate <= startDate) {
		// 	let temp = startDate;
		// 	startDate = endDate;
		// 	endDate = temp;
		// 	startTime = endTime;
		// 	endTime = time;
		// 	err = commonErr.FAIL;
		// 	errMsg = "Thời gian thuê xe không hợp lệ.";
		// } else {
		// 	startTime = time;
		// 	err = commonErr.SUCCESS;
		// 	errMsg = "";
		// }

		const hour = Number((endTime - time)/60)
		const isSameDay = endDate.format('DD/MM/YYYY') === startDate.format('DD/MM/YYYY');


		if (isSameDay && (0 <= hour && hour < 2)) {
			// this.setState({
			// 	err: commonErr.FAIL,
			// 	errMsg: "Thời gian kết thúc phải lớn hơn thời gian bắt đầu 2 tiếng"
			// });
			return;
		} else if (startDate.valueOf() > endDate.valueOf()) {
			// this.setState({
			// 	err: commonErr.FAIL,
			// 	errMsg: "Thời gian thuê xe không hợp lệ."
			// });
			return;
		}

		
		if (this.isSD) {
			this.getCarPriceAndCheckTime({
				selfPickup,
				startDate,
				endDate,
				fromAddress,
				fromAddressLat,
				fromAddressLng,
				promoCode,
				calendar,
				deliveryId,
			});
	
		} else {
			// WD
			let locations = isCityTourMode ? wdLocations.split(",")[0] : wdLocations;
			wdDistance = isCityTourMode ? 0 : wdDistance;

			if (selectHour > 0) {
				endDate = getEndDatewd(selectHour, startDate);
				endTime = endDate.get('hour') * 60 + endDate.get('minute')

				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance,
					wdDistanceBackOW,
					wdOneWay,
					wdLocations: locations,
					calendar: calendar.wdCalendar,
					deliveryId,
				});
			} else {
				let wdMinHourDetected = checkWdMinHour(
					isCityTourMode,
					wdOneWay,
					wdDistance,
					startDate,
					endDate,
					this.wdMinHour
				);
				this.setState({
					wdMinHourDetected,
				});

				if (!wdMinHourDetected) {
					this.getCarPriceAndCheckTime({
						startDate,
						endDate,
						fromAddressLat: locationArray[0].lat,
						fromAddressLng: locationArray[0].lng,
						promoCode,
						wdDistance,
						wdDistanceBackOW,
						wdOneWay,
						wdLocations: locations,
						calendar: calendar.wdCalendar,
						deliveryId,
					});
				}
			}
		}

	

		this.setState({
			startDate,
			endDate,
			startTime: time,
			endTime,
			err: commonErr.SUCCESS,
			errMsg: "",
		});
	};

	onEndTimeChange = (time) => {
		let {
			startDate,
			endDate,
			startTime,
			err,
			errMsg,
			selfPickup,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			promoCode,
			calendar,
			isCityTourMode,
			wdOneWay,
			wdDistance,
			wdDistanceBackOW,
			wdLocations,
			locationArray,
			selectHour,
			deliveryId,
		} = this.state;
		// const time = event.target.value;
		if (this.state.endDate && this.state.endDate.isValid()) {
			// const hour = (time - (time % 60)) / 60;
			// const min = time % 60;
			endDate = moment(this.state.endDate).set({
				hour: (time - (time % 60)) / 60,
				minute: time % 60,
				second: 0,
			});

			// if (endDate <= startDate) {
			// 	let temp = endDate;
			// 	endDate = startDate;
			// 	startDate = temp;
			// 	endTime = startTime;
			// 	startTime = time;
			// 	err = commonErr.FAIL;
			// 	errMsg = "Thời gian thuê xe không hợp lệ.";
			// } else {
			// 	endTime = time;
			// 	err = commonErr.SUCCESS;
			// 	errMsg = "";
			// }

			const hour = Number((time - startTime)/60)
			const isSameDay = endDate.format('DD/MM/YYYY') === startDate.format('DD/MM/YYYY');

			if (isSameDay && (0 <= hour && hour < 2)) {
				// this.setState({
				// 	err: commonErr.FAIL,
				// 	errMsg: "Thời gian kết thúc phải lớn hơn thời gian bắt đầu 2 tiếng"
				// });
				return;
			} else if (startDate.valueOf() > endDate.valueOf()) {
				// this.setState({
				// 	err: commonErr.FAIL,
				// 	errMsg: "Thời gian thuê xe không hợp lệ."
				// });
				return;
			}

			if (this.isSD) {
				this.getCarPriceAndCheckTime({
					selfPickup,
					startDate,
					endDate,
					fromAddress,
					fromAddressLat,
					fromAddressLng,
					promoCode,
					calendar,
					deliveryId,
				});
			} else {
				// WD
				let locations = isCityTourMode ? wdLocations.split(",")[0] : wdLocations;
				wdDistance = isCityTourMode ? 0 : wdDistance;

				if (selectHour > 0) {
					endDate = getEndDatewd(selectHour, startDate);
					endTime = endDate.get('hour') * 60 + endDate.get('minute')

					this.getCarPriceAndCheckTime({
						startDate,
						endDate,
						fromAddressLat: locationArray[0].lat,
						fromAddressLng: locationArray[0].lng,
						promoCode,
						wdDistance,
						wdDistanceBackOW,
						wdOneWay,
						wdLocations: locations,
						calendar: calendar.wdCalendar,
						deliveryId,
					});
				} else {
					let wdMinHourDetected = checkWdMinHour(
						isCityTourMode,
						wdOneWay,
						wdDistance,
						startDate,
						endDate,
						this.wdMinHour
					);
					this.setState({
						wdMinHourDetected,
					});

					if (!wdMinHourDetected) {
						this.getCarPriceAndCheckTime({
							startDate,
							endDate,
							fromAddressLat: locationArray[0].lat,
							fromAddressLng: locationArray[0].lng,
							promoCode,
							wdDistance,
							wdDistanceBackOW,
							wdOneWay,
							wdLocations: locations,
							calendar: calendar.wdCalendar,
							deliveryId,
						});
					}
				}
			}

			this.setState({
				startDate,
				endDate,
				startTime,
				endTime: time,
				err: commonErr.SUCCESS,
				errMsg: "",
			});
		} 
		

		
	};

	onPromoCodeClick = (promoCode) => {
		let {
			startDate,
			endDate,
			selfPickup,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			isCityTourMode,
			locationArray,
			wdDistance,
			wdDistanceBackOW,
			wdOneWay,
			wdLocations,
			deliveryId,
		} = this.state;
		this.setState({
			promoCode,
		});
		if (this.isSD) {
			this.getCarPriceAndCheckTime({
				selfPickup,
				startDate,
				endDate,
				fromAddress,
				fromAddressLat,
				fromAddressLng,
				promoCode,
				deliveryId,
			});
		} else {
			if (isCityTourMode) {

				if (!wdLocations || wdLocations === "") {
					wdLocations = `${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString(
						"base64"
					)}`;
				} else {
					wdLocations =  wdLocations.split(",")[0]
				}

				// city tour
				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance: 0,
					wdLocations: wdLocations,
					deliveryId,
				});
			} else {
				// across province
				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance,
					wdDistanceBackOW,
					wdOneWay,
					wdLocations,
					deliveryId,
				});
			}
		}
		cookie.save(this.isSD ? "_promo" : /*WD*/ "_promowd", JSON.stringify(promoCode), { path: "/" });
	};

	removePromoCode = () => {
		let {
			startDate,
			endDate,
			selfPickup,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			isCityTourMode,
			locationArray,
			wdDistance,
			wdDistanceBackOW,
			wdOneWay,
			wdLocations,
			deliveryId,
		} = this.state;
		this.setState({
			promoCode: "",
		});
		if (this.isSD) {
			this.getCarPriceAndCheckTime({
				selfPickup,
				startDate,
				endDate,
				fromAddress,
				fromAddressLat,
				fromAddressLng,
				promoCode: null,
				deliveryId,
			});
		} else {
			// WD
			if (isCityTourMode) {
				// city tour
				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode: null,
					wdDistance: 0,
					wdLocations: wdLocations.split(",")[0],
					deliveryId,
				});
			} else {
				// across province
				this.getCarPriceAndCheckTime({
					startDate,
					endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode: null,
					wdDistance,
					wdDistanceBackOW,
					wdOneWay,
					wdLocations,
					deliveryId,
				});
			}
		}

		cookie.remove(this.isSD ? "_promo" : "_promowd", { path: "/" });
	};

	openTimeSetting = () => {
		this.setState({
			showTimeSetting: true,
		});
	};

	closeTimeSetting = () => {
		this.setState({
			showTimeSetting: false,
		});
	};

	openWarningForm = () => {
		this.setState({
			showWarningForm: true,
		});
	};

	closeWarningForm = () => {
		this.setState({
			showWarningForm: false,
		});
	};

	openVerifyForm = () => {
		this.setState({
			showVerifyForm: true,
		});
	};

	closeVerifyForm = () => {
		this.setState({
			showVerifyForm: false,
		});
	};

	openVerifyLicense = () => {
		this.setState({
			showVerifyLicense: true,
		});
	};

	closeVerifyLicense = () => {
		this.setState({
			showVerifyLicense: false,
		});
	};

	openNotifLicense = () => {
		this.closeVerifyLicense();
		this.closeVerifyForm();

		this.setState({
			showNotifLicense: true,
		});
	};

	closeNotifLicense = () => {
		this.setState({
			showNotifLicense: false,
		});
	};

	showPromoBox = () => {
		this.setState({
			isOpenPromoBox: true,
		});
	};

	openPromoBox = (e) => {
		this.showPromoBox();
	};

	closePromoBox = () => {
		this.setState({
			isOpenPromoBox: false,
		});
	};

	openDetailIns = () => {
		this.setState({
			showDetailIns: true,
		});
	};

	closeDetailIns = () => {
		this.setState({
			showDetailIns: false,
		});
	};

	showWdTypeInfoBox = (wdType) => {
		this.setState({
			isShowWdTypeInfoBox: true,
			wdType,
		});
	};

	hideWdTypeInfoBox = () => {
		this.setState({
			isShowWdTypeInfoBox: false,
		});
	};

	rentCarBtnClick = (e) => {
		const { car } = this.state;
		const { loggedProfile } = this.props;

		if (!loggedProfile || !loggedProfile.uid) {
			this.props.showLoginForm();
		} else if (
			this.isSD &&
			car.requiredDriverLicense &&
			loggedProfile &&
			loggedProfile.phoneVerified === 1 &&
			((loggedProfile.driverLicenseStatus > 4 && loggedProfile.driverLicenseStatus < 40) ||
				loggedProfile.driverLicenseStatus < 1)
		) {
			this.openVerifyLicense();
		} else if (
			this.isSD &&
			car.requiredDriverLicense &&
			loggedProfile &&
			loggedProfile.phoneVerified !== 1 &&
			((loggedProfile.driverLicenseStatus > 4 && loggedProfile.driverLicenseStatus < 40) ||
				loggedProfile.driverLicenseStatus < 1)
		) {
			this.openVerifyForm();
		} else if (loggedProfile && loggedProfile.phoneVerified !== 1) {
			this.openWarningForm();
		} else if (loggedProfile && loggedProfile.uid === car.ownerId) {
			this.setState({
				isOwner: true,
			});
		} else {
			//GA
			const utmSrc = cookie.load("_utm_src") || "web_directly";
			const utmExt = cookie.load("_utm_ext") || "no_label";
			window.fbq("track", "CONFIRM_BOOKING");
			window.gtag("event", "CONFIRM_BOOKING", {
				event_category: utmSrc,
				event_label: utmExt,
				campaign: { source: utmSrc },
			});
			this.openBooking();
		}
	};

	getDayChildContent = (day) => {
		var child = "";
		let obj = {};
		var isShowPrice = day.isAfter(moment().subtract(1, "days"), "day");
		const invalidDays = this.state.invalidDays;
		const days = invalidDays.filter(function (invalidDay) {
			return invalidDay.date.isSame(day, "day") && day.isAfter(moment());
		});

		if (days.length !== 0) {
			isShowPrice = false;
			obj.unavail = function() {return <span class="full-in-calendar unavail-in-calendar"></span>};
			// child += `<span class="full-in-calendar unavail-in-calendar"></span>`;
		
		}


		const { calendar } = this.state;
		const _1dayInMSec = 24 * 3600000;
		const minWidth = 15;
		if (calendar) {
			const bookings = calendar.bookings;
		
			if (bookings) {
				for (var i = 0; i < bookings.length; i++) {
					const trip = bookings[i];
					if (
						day.isSame(moment(trip.startTime), "day") ||
						day.isSame(moment(trip.endTime), "day") ||
						day.isBetween(moment(trip.startTime), moment(trip.endTime))
					) {
						var width = 100;
						var left = 0;

						if (moment(trip.startTime).isSame(moment(trip.endTime), "day")) {
							width = ((trip.endTime - trip.startTime) * 100) / _1dayInMSec;
							left = 100 - ((moment(day).endOf("day").valueOf() - trip.startTime) * 100) / _1dayInMSec;
							if (width < minWidth) {
								left = left - (minWidth - width);
								width = minWidth;
							}
						} else if (moment(trip.endTime).isSame(day, "day")) {
							width = ((trip.endTime - moment(day).startOf("day").valueOf()) * 100) / _1dayInMSec;
						} else if (moment(trip.startTime).isSame(day, "day")) {
							left = ((trip.startTime - moment(day).startOf("day").valueOf()) * 100) / _1dayInMSec;
							if (left > 100 - minWidth) {
								left = 100 - minWidth;
							}
							width = 100 - left;
						}
						
						obj.booking = function() {return <span class="full-in-calendar unavail-in-calendar booking"></span>};
						// child += `<span class="full-in-calendar unavail-in-calendar" style="width: ${width}%; left: ${left}%;"></span>`;

						if (width === 100) {
							isShowPrice = false;
						}
						obj.booking = function() {return <span class="full-in-calendar unavail-in-calendar booking"></span>};
					}
				}
			}
		}
		if (this.isSD) {
			const priceSpecifics = this.state.priceSpecifics;
			const priceRepeat = this.state.priceRepeat;
			const priceRepeatEndDate = this.state.priceRepeatEndDate;
			const isLimitRepeatPrice = this.state.isLimitRepeatPrice;

			var price = this.state.priceDaily;
			var j;

			for (j = 0; j < priceRepeat.length; ++j) {
				const weekday = priceRepeat[j];
				if (
					weekday.price > 0 &&
					day.isoWeekday() === weekday.weekday &&
					(!isLimitRepeatPrice ||
						!priceRepeatEndDate ||
						priceRepeatEndDate === 0 ||
						day.valueOf() <= priceRepeatEndDate)
				) {
					price = weekday.price;
					break;
				}
			}

			for (j = 0; j < priceSpecifics.length; ++j) {
				if (day.isSame(moment(priceSpecifics[j].ts), "day")) {
					price = priceSpecifics[j].price;
					break;
				}
			}

			
			obj.child = function() {return <span className="price-in-calendar">{isShowPrice ? formatPrice(price) : ""}</span>};
			// child += `<span class="price-in-calendar">${isShowPrice ? formatPrice(price) : "&nbsp"}</span>`;
		}
		//- Instant Booking
		const instantDays = this.state.instantDays;
		for (j = 0; j < instantDays.length; ++j) {
			if (day.isSame(moment(instantDays[j]), "day")) {
				if (isShowPrice) {
					obj.instant = function() {return <svg className="instant-in-calendar" width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.72983 5.77414L4.34982 10.6991C4.21982 10.8941 4.00983 10.9991 3.78483 10.9991C3.71483 10.9991 3.64482 10.9891 3.57482 10.9691C3.28982 10.8791 3.09483 10.6241 3.09483 10.3291V7.50914C3.09483 7.39414 2.98482 7.29414 2.84982 7.29414L0.834823 7.26915C0.579823 7.26915 0.344827 7.12414 0.229827 6.90414C0.119827 6.68914 0.134825 6.42915 0.274825 6.22415L3.64983 1.29915C3.81983 1.04915 4.13483 0.939142 4.42483 1.02914C4.70983 1.11914 4.90482 1.37414 4.90482 1.66914V4.48915C4.90482 4.60415 5.01483 4.70414 5.14983 4.70414L7.16483 4.72914C7.41983 4.72914 7.65482 4.86914 7.76982 5.09414C7.87982 5.30914 7.86483 5.56914 7.72983 5.77414Z" fill="#5FCF86" />
                  	</svg>};
				// 	child += `<svg class="instant-in-calendar" width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                //     <path d="M7.72983 5.77414L4.34982 10.6991C4.21982 10.8941 4.00983 10.9991 3.78483 10.9991C3.71483 10.9991 3.64482 10.9891 3.57482 10.9691C3.28982 10.8791 3.09483 10.6241 3.09483 10.3291V7.50914C3.09483 7.39414 2.98482 7.29414 2.84982 7.29414L0.834823 7.26915C0.579823 7.26915 0.344827 7.12414 0.229827 6.90414C0.119827 6.68914 0.134825 6.42915 0.274825 6.22415L3.64983 1.29915C3.81983 1.04915 4.13483 0.939142 4.42483 1.02914C4.70983 1.11914 4.90482 1.37414 4.90482 1.66914V4.48915C4.90482 4.60415 5.01483 4.70414 5.14983 4.70414L7.16483 4.72914C7.41983 4.72914 7.65482 4.86914 7.76982 5.09414C7.87982 5.30914 7.86483 5.56914 7.72983 5.77414Z" fill="#5FCF86" />
                //   </svg>`;
				}
				break;
			}
		}
		return obj;
	};

	// getDayChildContent = (day) => {
	// 	var child = "";
	// 	var isShowPrice = day.isAfter(moment().subtract(1, "days"), "day");
	// 	const invalidDays = this.state.invalidDays;
	// 	const days = invalidDays.filter(function (invalidDay) {
	// 		return invalidDay.date.isSame(day, "day") && day.isAfter(moment());
	// 	});

	// 	if (days.length !== 0) {
	// 		isShowPrice = false;
	// 		return <span className="full-in-calendar unavail-in-calendar"></span>;
	// 	}

	// 	const calendar = this.state.calendar;
	// 	const _1dayInMSec = 24 * 3600000;
	// 	const minWidth = 15;
	// 	if (calendar) {
	// 		const bookings = calendar.bookings;
	// 		if (bookings) {
	// 			for (i = 0; i < bookings.length; ++i) {
	// 				const trip = bookings[i];
	// 				if (
	// 					day.isSame(moment(trip.startTime), "day") ||
	// 					day.isSame(moment(trip.endTime), "day") ||
	// 					day.isBetween(moment(trip.startTime), moment(trip.endTime))
	// 				) {
	// 					var width = 100;
	// 					var left = 0;

	// 					if (moment(trip.startTime).isSame(moment(trip.endTime), "day")) {
	// 						width = ((trip.endTime - trip.startTime) * 100) / _1dayInMSec;
	// 						left = 100 - ((moment(day).endOf("day").valueOf() - trip.startTime) * 100) / _1dayInMSec;
	// 						if (width < minWidth) {
	// 							left = left - (minWidth - width);
	// 							width = minWidth;
	// 						}
	// 					} else if (moment(trip.endTime).isSame(day, "day")) {
	// 						width = ((trip.endTime - moment(day).startOf("day").valueOf()) * 100) / _1dayInMSec;
	// 					} else if (moment(trip.startTime).isSame(day, "day")) {
	// 						left = ((trip.startTime - moment(day).startOf("day").valueOf()) * 100) / _1dayInMSec;
	// 						if (left > 100 - minWidth) {
	// 							left = 100 - minWidth;
	// 						}
	// 						width = 100 - left;
	// 					}

						

	// 					if (width === 100) {
	// 						isShowPrice = false;
	// 					}

	// 					return <span className="full-in-calendar unavail-in-calendar" style={`width: ${width}%; left: ${left}%;`}></span>
	// 				}
	// 			}
	// 		}
	// 	}
	// 	if (this.isSD) {
	// 		const priceSpecifics = this.state.priceSpecifics;
	// 		const priceRepeat = this.state.priceRepeat;
	// 		const priceRepeatEndDate = this.state.priceRepeatEndDate;
	// 		const isLimitRepeatPrice = this.state.isLimitRepeatPrice;

	// 		var price = this.state.priceDaily;
	// 		var j;

	// 		for (j = 0; j < priceRepeat.length; ++j) {
	// 			const weekday = priceRepeat[j];
	// 			if (
	// 				weekday.price > 0 &&
	// 				day.isoWeekday() === weekday.weekday &&
	// 				(!isLimitRepeatPrice ||
	// 					!priceRepeatEndDate ||
	// 					priceRepeatEndDate === 0 ||
	// 					day.valueOf() <= priceRepeatEndDate)
	// 			) {
	// 				price = weekday.price;
	// 				break;
	// 			}
	// 		}

	// 		for (j = 0; j < priceSpecifics.length; ++j) {
	// 			if (day.isSame(moment(priceSpecifics[j].ts), "day")) {
	// 				price = priceSpecifics[j].price;
	// 				break;
	// 			}
	// 		}

	// 		return <span className="price-in-calendar">{isShowPrice ? formatPrice(price) : ""}</span>
	// 	}
	// 	// - Instant Booking
	// 	const instantDays = this.state.instantDays;
	// 	for (j = 0; j < instantDays.length; ++j) {
	// 		if (day.isSame(moment(instantDays[j]), "day")) {
	// 			if (isShowPrice) {
	// 				// child += `<i class="ic ic-xs-thunderbolt instant-in-calendar"></i>`
	// 				return <svg className="instant-in-calendar" width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                 <path d="M7.72983 5.77414L4.34982 10.6991C4.21982 10.8941 4.00983 10.9991 3.78483 10.9991C3.71483 10.9991 3.64482 10.9891 3.57482 10.9691C3.28982 10.8791 3.09483 10.6241 3.09483 10.3291V7.50914C3.09483 7.39414 2.98482 7.29414 2.84982 7.29414L0.834823 7.26915C0.579823 7.26915 0.344827 7.12414 0.229827 6.90414C0.119827 6.68914 0.134825 6.42915 0.274825 6.22415L3.64983 1.29915C3.81983 1.04915 4.13483 0.939142 4.42483 1.02914C4.70983 1.11914 4.90482 1.37414 4.90482 1.66914V4.48915C4.90482 4.60415 5.01483 4.70414 5.14983 4.70414L7.16483 4.72914C7.41983 4.72914 7.65482 4.86914 7.76982 5.09414C7.87982 5.30914 7.86483 5.56914 7.72983 5.77414Z" fill="#5FCF86" />
    //               </svg>;
	// 			}
	// 			break;
	// 		}
	// 	}
	// 	return <span className="full-in-calendar unavail-in-calendar"></span>;
	// };

	isValidBooking = () => {
		// Common
		let ret =
			this.state.car &&
			!this.state.isOwner &&
			this.state.dateNotAvail <= 0 &&
			this.state.startDate &&
			this.state.endDate &&
			this.state.endDate.isValid() &&
			this.state.err >= commonErr.SUCCESS &&
			this.state.err !== commonErr.INNIT &&
			this.state.err !== commonErr.LOADING &&
			isEmptyObj(this.state.minTimesDetected) &&
			this.state.isValidPickupReturnTimes;
		if (this.isSD) {
			ret =
				ret &&
				(this.state.selfPickup || (this.state.fromAddress && this.state.fromAddress !== "")) &&
				this.state.startDate &&
				this.state.endDate &&
				this.state.endDate.isValid() &&
				this.state.car.priceSummary &&
				this.state.car.priceSummary.totalDays > 0 &&
				(!this.state.car.deliveryEnable || this.state.car.priceSummary.deliveryFee >= 0) &&
				this.state.err >= commonErr.SUCCESS &&
				this.state.err !== commonErr.INNIT &&
				this.state.err !== commonErr.LOADING;
		} else {
			ret =
				ret &&
				this.state.car.wdFull.priceSummary &&
				this.state.car.wdFull.priceSummary.deliveryFee >= 0 &&
				!this.state.errMsg &&
				!this.state.wdMinHourDetected &&
				((this.state.addressArray[0] !== "" && this.state.isCityTourMode) ||
					(!this.state.addressArray.includes("") && !this.state.isCityTourMode));
		}

		return ret;
	};

	openBooking = () => {
		this.setState({
			isShowBooking: true,
		});
	};

	closeBooking = () => {
		this.setState({
			isShowBooking: false,
		});
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.SUCCESS,
			errMsg: "",
		});
	};

	calculateAndDisplayRoute = (wdOneWay, locAddress) => {

		if (mapSdk != 0) {
			initMap(wdOneWay, this.map, locAddress, false, "", stypes.WD);
			return;
		}
	};

	onAddressFocus = (event, i) => {
		const addressArray = [...this.state.addressArray];
		addressArray[i] = "";
		const locationArray = [...this.state.locationArray];
		locationArray[i] = undefined;
		this.setState({
			errMsg: "Vui lòng nhập điểm đến",
			wdMinHourDetected: undefined,
			addressArray,
			locationArray,
		});
	};

	onAddressChange = (address, i) => {
		const addressArray = [...this.state.addressArray];
		addressArray[i] = address;
		this.setState({
			addressArray,
		});
	};

	onSelectAddress = (address, i) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			// success
			const { isCityTourMode, wdOneWay, startDate, endDate, promoCode, initData, car, deliveryId } = this.state;
			const wdMinHour = isCityTourMode ? initData.wdMinHourCT : wdOneWay ? initData.wdMinHourOW : initData.wdMinHour;
			const addressArray = [...this.state.addressArray];
			addressArray[i] = address.address;

			// parse location
			parseAddressToLocationWithLatLng(address.address, address.lat, address.lng, (location) => {
				const locationArray = [...this.state.locationArray];
				locationArray[i] = location;

				// if (isCityTourMode) { // city tour
				//     this.calculateAndDisplayRoute(wdOneWay, [locationArray[0]]);
				//     const cwdLocationsArray = this.state.wdLocations.split(",")
				//     cwdLocationsArray[0] = locationArray[0].lat + '-' + locationArray[0].lng + '-' + Buffer.from(address.address).toString('base64')
				// 	const wdLocations = cwdLocationsArray.join(",")

				//     this.setState({
				//         errMsg: "",
				//         addressArray,
				//         locationArray,
				//         wdLocations,
				//         deliveryAddressChangedFlag: true,
				//         locAddress: [locationArray[0]]
				//     })

				// 	this.getCarPriceAndCheckTime({ startDate, endDate, fromAddressLat: locationArray[0].lat, fromAddressLng: locationArray[0].lng, promoCode, wdDistance: 0, wdLocations: wdLocations.split(",")[0], deliveryId })

				// } else {

	
				if (addressArray.includes("")) {
					this.setState({
						addressArray,
						locationArray,
					});
				} else {
					this.calculateAndDisplayRoute(wdOneWay, locationArray);

					calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
						// format wdLocations
						let wdLocations = "";
						for (let i = 0; i < addressArray.length; i++) {
							wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
								"base64"
							)}${i !== addressArray.length - 1 ? "," : ""}`;
						}

						let wdMinHourDetected = checkWdMinHour(
							isCityTourMode,
							wdOneWay,
							wdDistance,
							startDate,
							endDate,
							this.wdMinHour
						);

						const time = this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);

						this.setState({
							errMsg: "",
							endDate: time.endDate,
							endTime: time.endTime,
							selectHour: time.selectHour,
							durationTimeArr: time.durationTimeArr,
							addressArray,
							locationArray,
							wdLocations,
							wdDistance,
							wdDistanceOW,
							wdDistanceBackOW,
							locAddress: locationArray,
						});

						this.getCarPriceAndCheckTime({
							startDate,
							endDate: time.endDate,
							fromAddressLat: locationArray[0].lat,
							fromAddressLng: locationArray[0].lng,
							promoCode,
							wdDistance,
							wdDistanceBackOW,
							wdOneWay,
							wdLocations,
							deliveryId,
						});
					});
				}
				// }
			});
		}
	};

	onAddStopPoint = () => {
		const { addressArray, locationArray, isCityTourMode } = this.state;
		if (addressArray.length >= 5) return;
		if (isCityTourMode) {
			this.setState({
				isCityTourMode: false,
				addressArray: [addressArray[0], ""],
				locationArray: [locationArray[0], undefined],
				deliveryAddressChangedFlag: false,
			});
		} else {
			this.setState({
				addressArray: [...addressArray, ""],
				locationArray: [...locationArray, undefined],
			});
		}
	};

	onRemoveStopPoint = (i) => {
		const { isCityTourMode, wdOneWay, startDate, endDate, promoCode, initData, deliveryId } = this.state;
		const wdMinHour = isCityTourMode ? initData.wdMinHourCT : wdOneWay ? initData.wdMinHourOW : initData.wdMinHour;
		const addressArray = [...this.state.addressArray];
		addressArray.splice(i, 1);
		const locationArray = [...this.state.locationArray];
		locationArray.splice(i, 1);

		// } else { // >=2 address
		if (addressArray.includes("")) {
			this.setState({
				addressArray,
				locationArray,
			});
		} else {
			// compute distance
			this.calculateAndDisplayRoute(wdOneWay, locationArray, this.state.map);
			calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
				// format wdLocations
				let wdLocations = "";
				for (let i = 0; i < addressArray.length; i++) {
					wdLocations += `${locationArray[i].lat}-${locationArray[i].lng}-${Buffer.from(addressArray[i]).toString(
						"base64"
					)}${i !== addressArray.length - 1 ? "," : ""}`;
				}
				// access province
				let wdMinHourDetected = checkWdMinHour(
					isCityTourMode,
					wdOneWay,
					wdDistance,
					startDate,
					endDate,
					this.wdMinHour
				);
				const time = this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);

				this.setState({
					errMsg: "",
					addressArray,
					locationArray,
					wdLocations,
					wdDistance,
					wdDistanceOW,
					wdDistanceBackOW,
					// locAddress: locationArray,
					endDate: time.endDate,
					endTime: time.endTime,
					selectHour: time.selectHour,
					durationTimeArr: time.durationTimeArr,
				});

				this.getCarPriceAndCheckTime({
					startDate,
					endDate: time.endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance,
					wdDistanceBackOW,
					wdOneWay,
					wdLocations: wdLocations,
					deliveryId,
				});
			});
		}
	};

	onTripModeChange = (tripMode) => {
		let value = tripMode.isCityTourMode;
		let wdOneWay = tripMode.wdOneWay;

		const {
			initData,
			addressArray,
			locationArray,
			wdDistance,
			wdDistanceBackOW,
			startDate,
			endDate,
			deliveryAddressChangedFlag,
			promoCode,
			deliveryId,
		} = this.state;
		let { wdLocations } = this.state;
		const wdMinHour = value ? initData.wdMinHourCT : wdOneWay ? initData.wdMinHourOW : initData.wdMinHour;

		this.setState({
			isCityTourMode: value,
			wdOneWay: wdOneWay
		});

		if (value === false && addressArray.length === 1) return;

		if (value === true) {
			//switch to city tour
			if (addressArray[0] === "") {
				this.setState({
					isCityTourMode: value,
				});
			} else {
				// city tour
				if (!wdLocations || wdLocations === "") {
					wdLocations = `${locationArray[0].lat}-${locationArray[0].lng}-${Buffer.from(addressArray[0]).toString(
						"base64"
					)}`;
				
				}

				this.calculateAndDisplayRoute(wdOneWay, [locationArray[0]], this.state.map);

				const time = this.getDurationTime(value, wdMinHour, 0);
				this.setState({
					errMsg: "",
					isCityTourMode: value,
					locAddress: [locationArray[0]],
					endDate: time.endDate,
					endTime: time.endTime,
					selectHour: time.selectHour,
					durationTimeArr: time.durationTimeArr,
				});

				this.getCarPriceAndCheckTime({
					startDate,
					endDate: time.endDate,
					fromAddressLat: locationArray[0].lat,
					fromAddressLng: locationArray[0].lng,
					promoCode,
					wdDistance: 0,
					wdLocations: wdLocations.split(",")[0],
					deliveryId,
				});
			}
		} else {
			//switch to across province
			if (addressArray.includes("")) {
				this.setState({
					errMsg: "Vui lòng nhập điểm đến",
					// isCityTourMode: value,
				});
			} else {
				this.calculateAndDisplayRoute(wdOneWay, locationArray, this.state.map);

				if (deliveryAddressChangedFlag) {
					calculateDistance(wdOneWay, locationArray, (wdDistance, wdDistanceOW, wdDistanceBackOW) => {
						const time = this.getDurationTime(value, wdMinHour, wdDistance);
						this.setState({
							// isCityTourMode: value,
							wdDistance,
							wdDistanceOW,
							wdDistanceBackOW,
							deliveryAddressChangedFlag: false,
							locAddress: locationArray,
							endDate: time.endDate,
							endTime: time.endTime,
							selectHour: time.selectHour,
							durationTimeArr: time.durationTimeArr,
						});

						this.getCarPriceAndCheckTime({
							startDate,
							endDate: time.endDate,
							fromAddressLat: locationArray[0].lat,
							fromAddressLng: locationArray[0].lng,
							promoCode,
							wdDistance,
							wdDistanceBackOW,
							wdOneWay,
							wdLocations: wdLocations,
							deliveryId,
						});
					});
				} else {
					// across province
					const time = this.getDurationTime(value, wdMinHour, wdDistance);

					this.setState({
						// isCityTourMode: value,
						// wdMinHourDetected,
						locAddress: locationArray,
						endDate: time.endDate,
						endTime: time.endTime,
						selectHour: time.selectHour,
						durationTimeArr: time.durationTimeArr,
					});

					this.getCarPriceAndCheckTime({
						startDate,
						endDate: time.endDate,
						fromAddressLat: locationArray[0].lat,
						fromAddressLng: locationArray[0].lng,
						promoCode,
						wdDistance,
						wdDistanceBackOW,
						wdOneWay,
						wdLocations: wdLocations,
						deliveryId,
					});
				}
			}
		}
	};

	onOneWayChange = () => {
		const wdOneWay = !this.state.wdOneWay;
		if (this.state.addressArray.includes("")) {
			this.setState({
				wdOneWay,
			});
		} else {
			this.calculateAndDisplayRoute(wdOneWay, this.state.locationArray, this.state.map);
			const {
				initData,
				isCityTourMode,
				locationArray,
				wdLocations,
				wdDistanceOW,
				wdDistanceBackOW,
				startDate,
				endDate,
				promoCode,
				deliveryId,
			} = this.state;
			const wdDistance = wdOneWay ? wdDistanceOW : wdDistanceOW + wdDistanceBackOW;
			const wdMinHour = isCityTourMode ? initData.wdMinHourCT : wdOneWay ? initData.wdMinHourOW : initData.wdMinHour;
			const time = this.getDurationTime(isCityTourMode, wdMinHour, wdDistance);
			this.setState({
				wdOneWay,
				wdDistance,
				endDate: time.endDate,
				endTime: time.endTime,
				selectHour: time.selectHour,
				durationTimeArr: time.durationTimeArr,
			});

			this.getCarPriceAndCheckTime({
				startDate,
				endDate: time.endDate,
				fromAddressLat: locationArray[0].lat,
				fromAddressLng: locationArray[0].lng,
				promoCode,
				wdDistance,
				wdDistanceBackOW,
				wdOneWay,
				wdLocations,
				deliveryId,
			});
		}
	};

	checkMinTimes = (startDate, endDate, totalDays, calendar) => {
		let { minTimes, minTimesRepeat, minTimesRepeatEndDate } = calendar;
		var now = new Date();

		// invalid
		if (minTimes) {
			minTimes = minTimes || [];
			for (let minTime of minTimes) {
				if (
					startDate.isBetween(moment(minTime.s), moment(minTime.e)) ||
					endDate.isBetween(moment(minTime.s), moment(minTime.e))
				) {
					// compare in day unit
					if (totalDays < minTime.h / 24) {
						this.setState({
							minTimesDetected: {
								s: moment(minTime.s),
								e: moment(minTime.e),
								dayNumbers: minTime.h / 24,
							},
						});
					} else {
						this.setState({
							minTimesDetected: {},
						});
					}
				} else {
					this.setState({
						minTimesDetected: {},
					});
				}
			}
		}

		if (
			(minTimesRepeatEndDate == 0 || (minTimesRepeatEndDate > 0 && minTimesRepeatEndDate > moment().valueOf())) &&
			minTimesRepeat
		) {
			let startTimeInSeconds = new Date(startDate);
			startTimeInSeconds.setHours(0);
			startTimeInSeconds.setMinutes(0);
			startTimeInSeconds = startTimeInSeconds / 1000;

			let endTimeInSeconds = new Date(endDate);
			endTimeInSeconds.setHours(0);
			endTimeInSeconds.setMinutes(0);
			endTimeInSeconds = endTimeInSeconds / 1000;
			var minTimesStr;

			this.setState({
				minTimesRepeatDetected: "",
			});

			for (let i = 0; i < minTimesRepeat.length; i++) {
				if (minTimesStr !== "") {
					minTimesStr += ", ";
				}
				var timeInSeconds = startTimeInSeconds;
				do {
					var date = new Date();
					date.setTime(timeInSeconds * 1000);
					var weekday = date.getDay() + 1;

					if (weekday === minTimesRepeat[i].weekday) {
						if (totalDays < minTimesRepeat[i].minHours / 24) {
							this.setState({
								minTimesRepeatDetected:
									"Thời gian thuê xe tối thiểu vào " +
									convertToWeekDayString(weekday) +
									" là " +
									minTimesRepeat[i].minHours / 24 +
									" ngày",
							});
							break;
						} else {
							this.setState({
								minTimesRepeatDetected: "",
							});
						}

						return;
					}

					timeInSeconds += 86400;
				} while (timeInSeconds <= endTimeInSeconds);
			}
		}

		// valid
		// if (this.state.minTimesDetected) {
		//     this.setState({
		//         minTimesDetected: {},
		//     })
		// }
	};

	checkPickupReturnTimes = (startDate, endDate, calendar) => {
		const { pickupTimes, returnTimes } = calendar;
		/* NOTE: below code have
				+ clone value moment object
				+ add, subtract 1 seconds for equation case in isBetween method
		*/
		let mmPickup = [];
		let mmReturn = [];
		let isValidPickupReturnTimes = true;

		if (pickupTimes) {
			pickupTimes.map((pickupTime) => {
				const pickupFromTime = pickupTime.s / 3600;
				const pickupToTime = pickupTime.e / 3600;
				const from = moment(startDate.valueOf()).startOf("day").add(pickupFromTime, "hours").subtract(1, "seconds");
				const to = moment(startDate.valueOf()).startOf("day").add(pickupToTime, "hours").add(1, "seconds");
				mmPickup.push({ from, to });
			});

			if (mmPickup.length > 1) {
				for (let i = 0; i < mmPickup.length - 1; i++) {
					if (
						!startDate.isBetween(mmPickup[i].from, mmPickup[i].to) &&
						!startDate.isBetween(mmPickup[i + 1].from, mmPickup[i + 1].to)
					) {
						isValidPickupReturnTimes = false;
					}
				}
			} else {
				if (!startDate.isBetween(mmPickup[0].from, mmPickup[0].to)) {
					isValidPickupReturnTimes = false;
				}
			}
		}

		if (returnTimes) {
			returnTimes.map((returnTime) => {
				const returnFromTime = returnTime.s / 3600;
				const returnToTime = returnTime.e / 3600;
				const from = moment(endDate.valueOf()).startOf("day").add(returnFromTime, "hours").subtract(1, "seconds");
				const to = moment(endDate.valueOf()).startOf("day").add(returnToTime, "hours").add(1, "seconds");
				mmReturn.push({ from, to });
			});

			if (mmReturn.length > 1) {
				for (let i = 0; i < mmReturn.length - 1; i++) {
					if (
						!endDate.isBetween(mmReturn[i].from, mmReturn[i].to) &&
						!endDate.isBetween(mmReturn[i + 1].from, mmReturn[i + 1].to)
					) {
						isValidPickupReturnTimes = false;
					}
				}
			} else {
				if (!endDate.isBetween(mmReturn[0].from, mmReturn[0].to)) {
					isValidPickupReturnTimes = false;
				}
			}
		}

		this.setState({
			isValidPickupReturnTimes,
		});
	};

	checkTimes = (startDate, endDate, totalDays, calendar) => {
		if (!calendar) return;
		this.checkMinTimes(startDate, endDate, totalDays, calendar);
		this.checkPickupReturnTimes(startDate, endDate, calendar);
	};

	setWdRoute = (wdRoute) => {
		this.setState({
			wdRoute,
		});
	};

	getDurationTime = (wdMode, wdMinHour, distance) => {
		let { selectHour } = this.state;
		const startDate = this.state.startDate.clone();
		let durationTimeArr = getDurationTime(wdMode, wdMinHour, distance);

		let endDate;
		let endTime;

		if (durationTimeArr[1] > selectHour) {
			selectHour = durationTimeArr[1];
			endDate = getEndDatewd(durationTimeArr[1], startDate);
			endTime = endDate.get('hour') * 60 + endDate.get('minute');
		} else {
			endDate = getEndDatewd(selectHour, startDate);
			endTime = endDate.get('hour') * 60 + endDate.get('minute');
		}

		return { endDate, endTime, durationTimeArr, selectHour };
	};

	toggleDurationTimeBox = (isSelectHour) => {
		// const { isSelectHour } = this.state;

		this.setState({
			isSelectHour: !isSelectHour,
		});
	};

	handleClickSameValue = (time) => {
		// const { selectHour } = this.state;
		// if (time === selectHour) {
		// 	this.setState({
		// 		isSelectHour: false
		// 	})
		// }
		// return;
	};

	onSelectHourChange = (event) => {
		let {
			endDate,
			endTime,
			isCityTourMode,
			locationArray,
			promoCode,
			wdDistance,
			wdDistanceBackOW,
			wdLocations,
			wdOneWay,
			calendar,
			deliveryId,
		} = this.state;
		const { name } = event.target;
		const selectHour = Number(event.target.value);
		const startDate = this.state.startDate.clone();

		let locations = isCityTourMode ? wdLocations.split(",")[0] : wdLocations;
		wdDistance = isCityTourMode ? 0 : wdDistance;

		if (selectHour > 0) {
			endDate = getEndDatewd(selectHour, startDate);
			endTime = endDate.get('hour') * 60 + endDate.get('minute')

			this.setState({
				wdMinHourDetected: undefined,
				endDate: endDate,
				endTime: endTime
			});

			this.getCarPriceAndCheckTime({
				startDate,
				endDate,
				fromAddressLat: locationArray[0].lat,
				fromAddressLng: locationArray[0].lng,
				promoCode,
				wdDistance,
				wdDistanceBackOW,
				wdOneWay,
				wdLocations: locations,
				calendar: calendar.wdCalendar,
				deliveryId,
			});
		}

		this.setState({
			[name]: selectHour,
			isSelectHour: false,
		});
	};

	getPickupAndReturnTimes = (calendar) => {
		const { pickupTimes, returnTimes } = calendar;
		let pickupTimesStr = "";
		let returnTimesStr = "";

		if (pickupTimes) {
			for (let i = 0; i < pickupTimes.length; i++) {
				if (pickupTimes[0].s === 0 && (pickupTimes[0].e === 84600 || pickupTimes[0].e === 86400)) {
					pickupTimesStr = "";
					break;
				}
				pickupTimesStr += `${formatSecondTime(pickupTimes[i].s)}-${formatSecondTime(pickupTimes[i].e)}${
					i !== pickupTimes.length - 1 ? `, ` : ""
				}`;
			}
		}

		if (returnTimes) {
			for (let i = 0; i < returnTimes.length; i++) {
				if (returnTimes[0].s === 0 && (returnTimes[0].e === 84600 || returnTimes[0].e === 86400)) {
					returnTimesStr = "";
					break;
				}

				returnTimesStr += `${formatSecondTime(returnTimes[i].s)}-${formatSecondTime(returnTimes[i].e)}${
					i !== returnTimes.length - 1 ? `, ` : ""
				}`;
			}
		}

		this.setState({
			pickupTimesStr,
			returnTimesStr,
		});
	};

	showChangePhone = () => {
		this.setState({
			showChangePhone: true,
		});
		this.closeWarningForm();
	};

	hideChangePhone = () => {
		this.setState({
			showChangePhone: false,
		});
	};

	showVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: true,
		});
	};

	hideVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: false,
		});
	};

	showVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: true,
		});
	};

	hideVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: false,
		});
	};

	showChangeDriverLicense = () => {
		this.setState({
			showChangeDriverLicense: true,
		});
		this.closeNotifLicense();
	};

	hideChangeDriverLicense = () => {
		this.setState({
			showChangeDriverLicense: false,
		});
	};

	onInsChange = (e) => {
		let activeIns = parseInt(e.target.value);

		this.setState({
			activeIns,
		});
	};

	toggleSType = () => {
		const { car } = this.state;

		if (this.isSD) {
			window.location.href = `/car/wd/${formatTitleInUrl(car.name)}/${car.id}`;
		} else {
			window.location.href = `/car/${formatTitleInUrl(car.name)}/${car.id}`;
		}
	};

	showDatePicker = () => {
		this.setState({
			showDateRangePicker: true,
		});
	};

	hideDatePicker = () => {
		this.setState({
			showDateRangePicker: false,
		});
	};

	openCalendar = () => {
		this.setState({
			isCalendar: true
		})
	}

	hideCalendar = () => {
		this.setState({
			isCalendar: false
		})
	}

	openWDCalendar = () => {
		this.setState({
			isDateBox: true
		})
	}

	hideWDCalendar = () => {
		this.setState({
			isDateBox: false
		})
	}

	// calendarTemplate = (pickupTimes, returnTimes, minTimesDetected, minTimesRepeatDetected) => {
	// 	return `<div class="daterangepicker dropdown-menu home">
    //                     <p class="c-title">Chọn ngày</p>
    //                     <div class="calendar left">
    //                         <div class="calendar-table" style="min-height: 321px"></div>
    //                         <div class="daterangepicker_input">
    //                             <div class="line"></div>
    //                             <p class="c-title">Chọn giờ</p>
    //                             <div class="calendar-time">
    //                                 <p class='pickup'>Giờ nhận xe: <span class="text-primary" style="font-weight: 600">${pickupTimes}</span></p>
    //                                 <div></div>
    //                             </div>
    //                             ${
	// 																!isEmptyObj(minTimesDetected) && minTimesDetected
	// 																	? `<p class="font-12 text-primary" style="height: 18px; padding-top: 10px; padding-left: 5px">* Thời gian thuê tối thiểu từ ${minTimesDetected.s.format(
	// 																			"DD/MM/YYYY"
	// 																	  )} đến ${minTimesDetected.e.format("DD/MM/YYYY")} là ${
	// 																			minTimesDetected.dayNumbers % 1 > 0
	// 																				? minTimesDetected.dayNumbers - (minTimesDetected.dayNumbers % 1) + 1
	// 																				: minTimesDetected.dayNumbers
	// 																	  } ngày</p>`
	// 																	: ""
	// 															}
	// 								${
	// 									minTimesRepeatDetected !== ""
	// 										? `<p class="font-12 text-primary" style="height: 18px; padding-top: 10px; padding-left: 5px">* ${minTimesRepeatDetected}</p>`
	// 										: ""
	// 								}
    //                         </div>
    //                     </div>
    //                     <div class="calendar right">
    //                         <div class="calendar-table" style="min-height: 321px"></div>
    //                         <div class="daterangepicker_input">
    //                             <div class="line"></div>
    //                             <p class='c-title' style="height: 24px;"></p>
    //                             <div class="calendar-time">
    //                                 <p class='pickup'>Giờ trả xe: <span class="text-primary" style="font-weight: 600">${returnTimes}</span></p>
    //                                 <div></div>
    //                             </div>
    //                             ${
	// 																(!isEmptyObj(minTimesDetected) && minTimesDetected) || minTimesRepeatDetected !== ""
	// 																	? `<p style="height: 18px; padding-top: 10px"></p>`
	// 																	: ""
	// 															}
    //                         </div>
    //                     </div>
    //                     <div class="ranges"> 
    //                         <div class="range_inputs"> 
    //                             <button class="applyBtn" disabled="disabled" type="button"></button>  
    //                         </div> 
	// 				    </div> 
    //                 </div>`;
	// };

	tooltKMDesc = () => {
		return (
			<>
				Số km tối đa được đi bao gồm tổng số km di chuyển trên hành trình và di chuyển tại điểm đến theo yêu cầu của
				khách
			</>
		);
	};

	render() {
		let content;
		const { err } = this.state;

		if (this.props.carDetail && this.props.carDetail.detail) {
			const { isMCalendar } = this.props;
			const {
				startTime,
				endTime,
				calendar,
				dateNotAvail,
				promoCode,
				isOwner,
				wdMinHourDetected,
				addressArray,
				locationArray,
				isCityTourMode,
				addressPlaceHolder,
				wdDistance,
				wdOneWay,
				isHighlight,
				minTimesDetected,
				minTimesRepeatDetected,
				isValidPickupReturnTimes,
				isSelectHour,
				selectHour,
				durationTimeArr,
				pickupTimesStr,
				returnTimesStr,
				activeIns,
				phoneInsPjico,
				phoneInsMic,
				phoneInsPVI,
				phoneInsVNI,
				fromAddress,
				fromAddressLat,
				fromAddressLng,
				fromAddressType,
				isShowLocationDelivery,
				selfPickup,
				isShowBooking,
				isOpenPromoBox,
				isCalendar,
				isDateBox,
			} = this.state;

			let { errMsg } = this.state;
			const car = this.props.carDetail.detail.info;
			const priceMode = this.props.appInit?.data?.priceMode;
			const hiddenFeeMode = priceMode === 2;

			const priceSummary = this.isSD
				? car.priceSummary
				: car.wdFull && car.wdFull.priceSummary
				? car.wdFull.priceSummary
				: {};
			const startDate = this.state.startDate ? moment(this.state.startDate) : null;
			const endDate = this.state.endDate ? moment(this.state.endDate) : null;

			// const minDate = moment();
			// const maxDate = calendar ? moment(calendar.endDate).endOf("month") : moment().add(2, "month");
			const isSamePickupReturnTimes =
				pickupTimesStr !== "" && returnTimesStr !== "" && pickupTimesStr == returnTimesStr;

			const { loggedProfile } = this.props;
			let uid = loggedProfile && loggedProfile.uid ? this.props.session.profile.info.uid : undefined;
			let phonesIns =
				activeIns === 1 ? phoneInsMic : activeIns === 4 ? phoneInsVNI : activeIns === 3 ? phoneInsPVI : phoneInsPjico;

			let listAddress =
				loggedProfile && loggedProfile.uid && !isEmptyObj(this.props.session.addresses.info)
					? this.props.session.addresses.info
					: undefined;

			let isSelfPickup =
				selfPickup && fromAddressLat === 0 && fromAddressLng === 0 && fromAddress == "" && fromAddressType == 1;
			const { deliveryId } = this.state;

			const locAddress = this.isSD ? { lat: fromAddressLat, lng: fromAddressLng } : locationArray[0];

			const msgReturnPickup = () => {
				if (pickupTimesStr !== "" || returnTimesStr !== "") {
					if (isSamePickupReturnTimes) {
						return `giao nhận từ ${pickupTimesStr}`;
					} else {
						return `${
							pickupTimesStr !== "" ? `nhận xe từ ${pickupTimesStr} ${returnTimesStr !== "" ? "và" : ""} ` : ""
						} ${returnTimesStr !== "" ? `trả xe từ ${returnTimesStr}` : ""}`;
					}
				} else {
					return "";
				}
			};

		

			// if (err < commonErr.SUCCESS && errMsg === "") {
			// 	// errMsg = "Thời gian thuê xe không hợp lệ.";
				
			// } else 
			if (dateNotAvail > 0) {

					errMsg = "Xe bận trong khoảng thời gian trên. Vui lòng đặt xe khác hoặc thay đổi lịch trình thích hợp.";
			}
			
			let errBooking = '';

			if (calendar && calendar.bookings && calendar.bookings.length > 0) {
				for (var i = 0; i < calendar.bookings.length; i++) {
					const trip = calendar.bookings[i];
					if (startDate && endDate) {
						if (
							startDate.isSame(moment(trip.startTime), "day") ||
							startDate.isSame(moment(trip.endTime), "day") ||
							startDate.isBetween(moment(trip.startTime), moment(trip.endTime)) || 
							endDate.isSame(moment(trip.startTime), "day") ||
							endDate.isSame(moment(trip.endTime), "day") ||
							endDate.isBetween(moment(trip.startTime), moment(trip.endTime)) 
						) { 
							errBooking = `Xe đã được thuê từ ${moment(trip.startTime).format('HH:mm, DD/MM/YYYY')} đến ${moment(trip.endTime).format('HH:mm, DD/MM/YYYY')}`;
						}
					}
				}
			}

			

			const errorDate =
				!isEmptyObj(minTimesDetected) ||
				minTimesRepeatDetected !== "" ||
				(minTimesRepeatDetected && minTimesRepeatDetected !== "") ||
				errMsg !== "";

			content = (
				<>
					<Insurance
						activeIns={activeIns}
						insSupport={car.insSupport}
						openDetailIns={this.openDetailIns}
						isSD={this.isSD}
					/>
					<div className="rent-box" id="cardetail" style={{ position: "relative" }}>
						<div className="price">
							{this.isSD ? (
								<>
									{hiddenFeeMode ? (
										<>
											{priceSummary && car.priceOriginWithFee !== priceSummary.priceSpecialWithFee && (
												<div className="price-discount">
													<p className="origin">
														<NumberFormat
															value={formatPrice(car.priceOriginWithFee)}
															displayType={"text"}
															thousandSeparator={","}
															suffix={"K"}
														/> 
													</p>
													{car.totalDiscountPercent > 0 ? (
														<span className="tag-item discount">-{car.totalDiscountPercent}%</span>
													) : null}
												</div>
											)}
											{/* {car.priceOrigin !== priceSummary.priceSpecial && <h4 className="origin">{formatPrice(car.priceOrigin)}</h4>} */}
											{priceSummary && <h4>
												<NumberFormat
													value={formatPrice(priceSummary.priceSpecialWithFee)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> /ngày</h4>}
										</>
									) : (
										<>
											{priceSummary && car.priceOrigin !== priceSummary.priceSpecial && (
												<div className="price-discount">
													<p className="origin">
														<NumberFormat
															value={formatPrice(car.priceOrigin)}
															displayType={"text"}
															thousandSeparator={","}
															suffix={"K"}
														/> 
														</p>
													{car.totalDiscountPercent > 0 ? (
														<span className="tag-item discount">-{car.totalDiscountPercent}%</span>
													) : null}
												</div>
											)}
											{/* {car.priceOrigin !== priceSummary.priceSpecial && <h4 className="origin">{formatPrice(car.priceOrigin)}</h4>} */}
											{priceSummary && <h4>
												<NumberFormat
													value={formatPrice(priceSummary.priceSpecial)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
												/ngày</h4>}
										</>
									)}
								</>
							) : (
								<>
									{hiddenFeeMode ? (
										<>
											{priceSummary.totalPriceOriginWithFee !== priceSummary.specialPriceTotalWithFee && (
												<div className="price-discount">
													<p className="origin">
															<NumberFormat
															value={formatPrice(priceSummary.totalPriceOriginWithFee)}
															displayType={"text"}
															thousandSeparator={","}
															suffix={"K"}
															/> 
														</p>
													{car.wdShort && car.wdShort.totalDiscountPercent > 0 ? (
														<span className="tag-item discount">-{car.wdShort.totalDiscountPercent}%</span>
													) : null}
												</div>
											)}
											
													<h4> 
														<NumberFormat
															value={formatPrice(priceSummary && priceSummary.specialPriceTotalWithFee ? priceSummary.specialPriceTotalWithFee : car.wdShort?.priceWithFee)}
															displayType={"text"}
															thousandSeparator={","}
															suffix={"K"}
														/> /chuyến </h4>
										</>
									) : (
										<>
											{priceSummary.totalPriceOrigin !== priceSummary.specialPriceTotal && (
												<div className="price-discount">
													<p className="origin">
														<NumberFormat
															value={formatPrice(priceSummary.totalPriceOrigin)}
															displayType={"text"}
															thousandSeparator={","}
															suffix={"K"}
														/> 
														</p>
													{car.wdShort && car.wdShort.totalDiscountPercent > 0 ? (
														<span className="tag-item discount">-{car.wdShort.totalDiscountPercent}%</span>
													) : null}
												</div>
											)}
								
											<h4> 
														<NumberFormat
															value={formatPrice(priceSummary && priceSummary.specialPriceTotal ? priceSummary.specialPriceTotal : car.wdShort?.price)}
															displayType={"text"}
															thousandSeparator={","}
															suffix={"K"}
														/> 
														/chuyến </h4>
										
											
										</>
									)}
								</>
							)}
						</div>

						{this.isSD && (
							<>
							
							<div className={`date-time-form ${errorDate ? "error" : ""}`} onClick={this.openCalendar}>
									<div className="form-item">
										<label>Nhận xe </label>
										<div className="wrap-date-time">
											<div className="wrap-date">
												<span className="value">{startDate ? startDate.format("DD/MM/YYYY") : "Chọn ngày"}</span>
											</div>
											<div className="wrap-time">
												<span className="value">{startDate ? startDate.format("HH:mm") : "Chọn giờ"}</span>
											</div>
										</div>
									</div>
									<div className="line" />
									<div className="form-item">
										<label>Trả xe</label>
										<div className="wrap-date-time">
											<div className="wrap-date">
												<span className="value">{endDate ? endDate.format("DD/MM/YYYY") : <span className="font-13">Chọn ngày</span>}</span>
											</div>
											<div className="wrap-time">
												<span className="value">{endDate ? endDate.format("HH:mm") : <span className="font-13">Chọn giờ</span>}</span>
											</div>
										</div>
									</div>
								</div>

								{isCalendar && <Calendar 
									isMCalendar={isMCalendar}
									startDate={startDate} 
									endDate={endDate} 
									startTime={startTime}
									endTime={endTime}
									finding={false}
									onStartTimeChange={this.onStartTimeChange}
									onEndTimeChange={this.onEndTimeChange}
									onDatesChange={this.onDateRangeChange} 
									show={isCalendar}
									pickupTimesStr={pickupTimesStr}
									returnTimesStr={returnTimesStr}
									isSamePickupReturnTimes={isSamePickupReturnTimes}
									minTimesRepeatDetected={minTimesRepeatDetected}
									minTimesDetected={minTimesDetected}
									getDayChildContent={this.getDayChildContent}
									isValidPickupReturnTimes={isValidPickupReturnTimes}
									errMsg={errMsg}
									errBooking={errBooking}
									msgReturnPickup={msgReturnPickup}
									hideModal={this.hideCalendar}/>}

							</>
						)}

						{!this.isSD && (
							<>

								<div className={`date-time-form ${errorDate ? "error" : ""}`} onClick={this.openWDCalendar}>
									<div className="form-item">
										<label>Nhận xe </label>
										<div className="wrap-date-time">
											<div className="wrap-date">
												<span className="value">{startDate ? startDate.format("DD/MM/YYYY") : "Chọn ngày"}</span>
											</div>
											<div className="wrap-time">
												<span className="value">{startDate ? startDate.format("HH:mm") : "Chọn giờ"}</span>
											</div>
										</div>
									</div>
									<div className="line" />
									<div className="form-item">
										<label>Trả xe</label>
										<div className="wrap-date-time">
											<div className="wrap-date">
												<span className="value">{endDate ? endDate.format("DD/MM/YYYY") : <span className="font-12">Chọn ngày</span>}</span>
											</div>
											<div className="wrap-time">
												<span className="value">{endDate ? endDate.format("HH:mm") : <span className="font-12">Chọn giờ</span>}</span>
											</div>
										</div>
									</div>
								</div>

								{selectHour > 0 && (
									<p className="time-end font-14">
										Thời gian thuê xe: {selectHour} tiếng
									</p>
								)}

								{isDateBox && <CalendarWD 
									isMCalendar={isMCalendar}
									startDate={startDate} 
									endDate={endDate} 
									startTime={startTime}
									endTime={endTime}
									finding={false}
									onStartTimeChange={this.onStartTimeChange}
									onEndTimeChange={this.onEndTimeChange}
									onStartDateChange={this.onStartDateChange} 
									onDatesChange={this.onEndDateChange}
									wrapperSelect={this.wrapperSelectCD}
									toggleDurationTimeBox={this.toggleDurationTimeBox}
									onSelectHourChange={this.onSelectHourChange}
									selectHour={selectHour}
									durationTimeArr={durationTimeArr}
									isSelectHour={isSelectHour}
									show={isDateBox}
									
									filter={this.props.carFinding.filter}
									getDayChildContent={this.getDayChildContent}
									hideModal={this.hideWDCalendar}/>
								}

							</>
						)}

						{isOwner && (
							<div className="calendar d-flex">
								<div className="wrap-svg" style={{ marginBottom: "12px", marginRight: "5px" }}>
									<IcInfomationTriangle />
								</div>
								<p className="note text-danger">Bạn không thể thuê xe của mình.</p>
							</div>
						)}

				

						{errMsg !== "" &&
							!(
								(!isEmptyObj(minTimesDetected) || minTimesRepeatDetected !== "" || !isValidPickupReturnTimes || errBooking !== "") &&
								dateNotAvail > 0
							) && <MessageErr errMsg={errMsg} />}
						
						{errBooking !== "" && <MessageErr errMsg={errBooking} />}

						{minTimesDetected && !isEmptyObj(minTimesDetected) && (
							<MessageErr
								errMsg={`Thời gian thuê tối thiểu từ ${minTimesDetected.s.format(
									"DD/MM/YYYY"
								)} đến ${minTimesDetected.e.format("DD/MM/YYYY")} là ${
									minTimesDetected.dayNumbers % 1 > 0
										? minTimesDetected.dayNumbers - (minTimesDetected.dayNumbers % 1) + 1
										: minTimesDetected.dayNumbers
								} ngày`}
							/>
						)}

						{minTimesRepeatDetected !== "" && (
							<div className="calendar d-flex">
								<div className="wrap-svg" style={{ marginBottom: "12px", marginRight: "5px" }}>
									<IcInfomationTriangle />
								</div>
								<p className="note text-danger">{minTimesRepeatDetected}</p>
							</div>
						)}

						{wdMinHourDetected && (
							<MessageErr errMsg={`Thời gian thuê tối thiểu cho lộ trình trên là ${wdMinHourDetected} tiếng.`} />
						)}

						{this.isSD && !isValidPickupReturnTimes && (
							<MessageErr
								errMsg={`Thời gian thuê không hợp lệ.`}
							/>
						)}

						{this.isSD && car.discountEnable === 1 && car.discountWeekly > 0 && (
							<div className="dc-week-month">
								<p>
									{car.discountWeekly > 0 && (
										<>
											Thuê tuần giảm <strong>{car.discountWeekly}% </strong>
										</>
									)}
									{car.discountWeekly > 0 && car.discountMonthly > 0 && " - "}
									{car.discountMonthly > 0 && (
										<>
											Thuê tháng giảm <strong>{car.discountMonthly}%</strong>
										</>
									)}
								</p>
							</div>
						)}

					

						{this.isSD ? (
							<React.Fragment>
								{car.deliveryEnable === 1 ? (
									<React.Fragment>
										<div
											className={`dropdown-form ${priceSummary && priceSummary.deliveryFee === -1 ? "error" : ""}`}
											onClick={() => this.toggleLocationDelivery(isShowLocationDelivery)}>
											<label>Địa điểm giao nhận xe</label>
											<div className="wrap-form has-arrow">
												<span className="value">{fromAddress}</span>
											</div>
										</div>

										{isShowLocationDelivery && (
											<LocationDelivery
												car={car}
												show={isShowLocationDelivery}
												loggedProfile={loggedProfile}
												onHide={this.toggleLocationDelivery}
												onUpdate={this.onUpdateSDDelivery}
												address={fromAddress}
												location={{ lat: fromAddressLat, lng: fromAddressLng }}
												type={fromAddressType}
												selfPickup={selfPickup}
												getListAddress={this.getListAddress}
												listAddress={listAddress}
												startDate={startDate}
												endDate={endDate}
												deliveryId={deliveryId}
											/>
										)}

										{priceSummary && priceSummary.deliveryFee === -1 && (
											<div className="calendar d-flex">
												<div className="wrap-svg" style={{ marginBottom: "12px", marginRight: "5px" }}>
													<IcInfomationTriangle />
												</div>
												<p className="note text-danger">Địa điểm giao nhận xe quá xa so với vị trí xe</p>
											</div>
										)}
									</React.Fragment>
								) : (
									<React.Fragment>
										<div className="dropdown-form">
											<label>Địa điểm giao xe</label>
											<div className={`wrap-form ${car.deliveryEnable !== 1 ? "" : "has-arrow"}`}>
												<span className="value">{car.locationAddrS}</span>
											</div>
											{car.deliveryEnable !== 1 && (
												<p className="note">
													Rất tiếc, chủ xe không hỗ trợ giao xe tận nơi
												</p>
											)}
										</div>
									</React.Fragment>
								)}
							</React.Fragment>
						) : (
							/*WD*/
							<React.Fragment>
								<div className="pickup-wd">
						
								<p className="title-wd">Lộ trình</p>
								
								<div className="wd-option-form">
										<div className="custom-radio">
											<input
												type="radio"
												id="cityTourCD"
												name="tripModeCD"
												checked={isCityTourMode && !wdOneWay}
												onChange={() => this.onTripModeChange({isCityTourMode: true, wdOneWay: false})}
											/>
											<label htmlFor="cityTourCD">Nội thành</label>
										</div>
										<div className="custom-radio">
											<input
												type="radio"
												id="provinceCD"
												name="tripModeCD"
												checked={!isCityTourMode && !wdOneWay}
												onChange={() => this.onTripModeChange({isCityTourMode: false, wdOneWay: false})}
											/>
											<label htmlFor="provinceCD">Liên tỉnh</label>
										</div>
										<div className="custom-radio">
											<input
												type="radio"
												id="pOneWay"
												name="tripModeCD"
												checked={!isCityTourMode && wdOneWay}
												onChange={() => this.onTripModeChange({isCityTourMode: false, wdOneWay: true})}
											/>
											<label htmlFor="pOneWay">Liên tỉnh (1 chiều)</label>
										</div>
										
									</div>

									{isCityTourMode ? (
										<div className="note">
											Di chuyển nội thành hoặc lân cận, lộ trình tự do.
											<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_CITY_TOUR)}>
												<IcQuestion />
											</div>
										</div>
									) :  wdOneWay ? (
											<div className="note">
												Di chuyển liên tỉnh, trả khách về lại điểm đến.
												<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_ONEWAY)}>
													<IcQuestion />
												</div>
											</div>
										) : 
										
										<div className="note">
											Di chuyển liên tỉnh, trả khách tại điểm đón.
											<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_TWOWAY)}>
												<IcQuestion />
											</div>
										</div>
									}

									{!addressArray.includes("") && <div className="map-route">
										<div id="mapWD" ref={this.map} className="wrap-map" />
									</div>}
						
								
							


									{isCityTourMode ? (
										<>
											<div className="route-address">
												<p className="title">Điểm đón</p>
												<div
													className="route-address__item pointer"
													onClick={() => this.toggleLocationDelivery(isShowLocationDelivery)}>
													<div className="wrap-svg">
														<IcLocationGreen />
													</div>
													<p className="value">{addressArray[0]}</p>
												</div>
											</div>
											
										</>
									) : wdOneWay ? (
										<>
											<div className="route-address">
												
											
												{addressArray.map((address, index) => {
													return (
														<div
															className={`route-address__item ${index === 0 ? "pointer" : ""}`}
															key={index}
															onClick={
																index === 0 ? () => this.toggleLocationDelivery(isShowLocationDelivery) : undefined
															}>
															<div className="wrap-svg">{index === 0 ? <IcStartLocGreen /> : <IcEndLocGreen />}</div>

															{index === 0 ? (
																<p className="value">{addressArray[0]}</p>
															) : (
																<HereAutoComplete
																	theme="LIGHT"
																	hidden={false}
																	onSelect={(address) => this.onSelectAddress(address, index)}
																	locAddress={locAddress}
																	inputProps={{
																		value: address,
																		onChange: (address) => this.onAddressChange(address, index),
																		onFocus: (e) => this.onAddressFocus(e, index),
																	}}
																/>
															)}

															{!(index === 0 || index === 1) && (
																<div className="wrap-svg" onClick={() => this.onRemoveStopPoint(index)}>
																	<IcCloseOrange />
																</div>
															)}
														</div>
													);
												})}
												{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
													<div className="route-address__item add-address" onClick={this.onAddStopPoint}>
														<div className="wrap-svg">
															<IcPlusCGreen />
														</div>
														<p>Thêm điểm đến</p>
													</div>
												)}
											</div>

										
										</>
									) : 
									(
										<>
											<div className="route-address">
												
												{addressArray.map((address, index) => {
													return (
														<div
															className={`route-address__item ${index === 0 ? "pointer" : ""}`}
															key={index}
															onClick={
																index === 0 ? () => this.toggleLocationDelivery(isShowLocationDelivery) : undefined
															}>
															<div className="wrap-svg">{index === 0 ? <IcStartLocGreen /> : <IcEndLocGreen />}</div>

															{index === 0 ? (
																<p className="value">{addressArray[0]}</p>
															) : (
																<HereAutoComplete
																	theme="LIGHT"
																	hidden={false}
																	onSelect={(address) => this.onSelectAddress(address, index)}
																	locAddress={locAddress}
																	inputProps={{
																		value: address,
																		onChange: (address) => this.onAddressChange(address, index),
																		onFocus: (e) => this.onAddressFocus(e, index),
																	}}
																/>
															)}

															{!(index === 0 || index === 1) && (
																<div className="wrap-svg" onClick={() => this.onRemoveStopPoint(index)}>
																	<IcCloseOrange />
																</div>
															)}
														</div>
													);
												})}
												{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
													<div className="route-address__item add-address" onClick={this.onAddStopPoint}>
														<div className="wrap-svg">
															<IcPlusCGreen />
														</div>
														<p>Thêm điểm đến</p>
													</div>
												)}
											</div>

										</>
									)}
									{/* <div className="line-page" /> */}
									<div className="route-info">
										<p className="title">Thông tin lộ trình</p>
										{priceSummary && priceSummary.distanceInKM > 0 && wdDistance > 0 && (
											<div className="route-info__item">
												<p>Tổng lộ trình</p>
												<p className="cost">{priceSummary.distanceInKM.toFixed(1)}km</p>
											</div>
										)}
										{priceSummary &&
											priceSummary.limitKM > 0 &&
											((isCityTourMode && addressArray[0] !== "") ||
												(!isCityTourMode && !addressArray.includes(""))) && (
												<div className="route-info__item">
													<TooltipP title={"Số km được đi"} desc={this.tooltKMDesc} />
													<p className="cost">{priceSummary.limitKM}km</p>
												</div>
											)}
										<div className="route-info__item">
											<p>Phí phụ thu vượt {priceSummary && priceSummary.limitKM} km</p>
											<p className="cost">{priceSummary.extraKMFee} đ/km</p>
										</div>
										<div className="route-info__item">
											<p>Phí phụ thu vượt {priceSummary && priceSummary.totalHours} tiếng</p>
											<p className="cost">{priceSummary.extraHourFee} đ/giờ</p>
										</div>
									</div>
								</div>

								{priceSummary.deliveryFee === -1 && (
									<div className="calendar d-flex">
										<div className="wrap-svg" style={{ marginBottom: "12px", marginRight: "5px" }}>
											<IcInfomationTriangle />
										</div>
										<p className="note text-danger">Địa điểm đưa đón quá xa so với vị trí xe</p>
									</div>
								)}
							</React.Fragment>
						)}

						<div className="line-page" />

						<PriceSummary
							priceSummary={priceSummary}
							isSD={this.isSD}
							promo={promoCode && promoCode.code ? promoCode.code : null}
							car={true}
							openPromoBox={this.openPromoBox}
							removePromoCode={this.removePromoCode}
						/>
						<a
							className="btn btn-primary btn--m width-100"
							disabled={!this.isValidBooking()}
							onClick={this.rentCarBtnClick}>
							{((this.isSD && car.instant === 1) || (!this.isSD && car.wdShort && car.wdShort.instant === 1)) && (
								<div className="wrap-svg">
									<IcInstant />
								</div>
							)}
							CHỌN THUÊ
						</a>
					</div>

					{this.isSD && <Surcharge info={car} />}

					{!this.isSD && car.wdShort && (
						<div className="delivery-info">
							<p className="title">Thông tin đưa đón</p>
							<div className="delivery-container">
								<div className="delivery-item">
									<p>Hỗ trợ đưa đón trong vòng</p>
									<p className="cost">{car.wdShort.deliveryRadius}&nbsp;km</p>
								</div>
								<div className="delivery-item">
									<p>Phí đưa đón</p>
									<p className="cost">{formatPrice(car.wdShort.deliveryPrice)}&nbsp;/km</p>
								</div>
								{car.wdShort.deliveryRadiusFree > 0 && (
									<div className="delivery-item">
										<p>Miễn phí đưa đón trong vòng</p>
										<p className="cost">{car.wdShort.deliveryRadiusFree}&nbsp;km</p>
									</div>
								)}
							</div>
						</div>
					)}

					{!isOwner && (
						<div className="wrap-btn" onClick={this.props.onReportCar}>
							<a className="btn btn-link">
								<IcReport />
								Báo cáo xe này
							</a>
						</div>
					)}

					<VerifyPhoneBox
						show={this.state.showWarningForm}
						onHide={this.showWarningForm}
						showChangePhone={this.showChangePhone}
					/>

					<VerifyPhoneDL
						show={this.state.showVerifyForm}
						onHide={this.closeVerifyForm}
						openNotifLicense={this.openNotifLicense}
					/>
					<VerifyLicense
						show={this.state.showVerifyLicense}
						onHide={this.closeVerifyLicense}
						openNotifLicense={this.openNotifLicense}
					/>
					<LicenseForm
						show={this.state.showNotifLicense}
						onHide={this.closeNotifLicense}
						showChangeDriverLicense={this.showChangeDriverLicense}
					/>

					{!this.isSD && isShowLocationDelivery && locationArray && (
						<LocationDeliveryPickcerWD
							show={isShowLocationDelivery}
							onHide={this.toggleLocationDelivery}
							onUpdate={this.onUpdateWDDelivery}
							address={addressArray[0]}
							location={{ lat: locationArray[0].lat, lng: locationArray[0].lng }}
							startDate={startDate}
							endDate={endDate}
							loggedProfile={loggedProfile}
							getListAddress={this.getListAddress}
							listAddress={listAddress}
							car={car}
							deliveryId={deliveryId}
						/>
					)}

					{this.isSD ? (
						<InsuranceDetail
							show={this.state.showDetailIns}
							onHide={this.closeDetailIns}
							insBy={car.insBy}
							activeIns={activeIns}
							phonesIns={phonesIns}
							onInsChange={this.onInsChange.bind(this)}
						/>
					) : (
						<InsuranceWDDetail
							show={this.state.showDetailIns}
							onHide={this.closeDetailIns}
							insBy={car.insBy}
							activeIns={activeIns}
							phonesIns={phonesIns}
							onInsChange={this.onInsChange.bind(this)}
						/>
					)}

					{loggedProfile && loggedProfile.uid && (
						<ChangePhone
							show={this.state.showChangePhone}
							hideModal={this.hideChangePhone}
							getProfile={this.getProfile}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>
					)}
					{loggedProfile && loggedProfile.uid && (
						<ChangeDriverLicense
							show={this.state.showChangeDriverLicense}
							getProfile={this.getProfile}
							profile={this.props.session.profile}
							hideModal={this.hideChangeDriverLicense}
							showVerifyPhone={this.showChangePhone}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>
					)}

					{this.state.showVerifyPhoneOpt && (
						<VerifyPhoneOpt
							show={this.state.showVerifyPhoneOpt}
							hideModal={this.hideVerifyPhoneOpt}
							getProfile={this.getProfile}
							onBreakVerifyPhoneOtp={this.showVerifyPhoneOptBreak}
						/>
					)}
					{this.state.showVerifyPhoneOptBreak && (
						<VerifyPhoneOptBreak show={this.state.showVerifyPhoneOptBreak} hideModal={this.hideVerifyPhoneOptBreak} />
					)}

					{isOpenPromoBox && (
						<PromoBox
							show={isOpenPromoBox}
							onHide={this.closePromoBox}
							carId={car.id}
							onPromoCodeClick={this.onPromoCodeClick}
							stype={this.stype}
							startDate={startDate.valueOf()}
							endDate={endDate.valueOf()}
						/>
					)}
					<WdTypeInfoBox
						show={this.state.isShowWdTypeInfoBox}
						hideModal={this.hideWdTypeInfoBox}
						wdType={this.state.wdType}
					/>
					{isShowBooking && (
						<>
							{this.isSD ? (
								<CarBooking
									closePopup={this.props.closePopup}
									togglePopup={this.props.togglePopup}
									show={isShowBooking}
									hideModal={this.closeBooking}
									car={car}
									promoCode={promoCode}
									insuranceBy={activeIns}
									owner={this.props.owner}
									startDate={startDate}
									endDate={endDate}
									selfPickup={this.state.selfPickup}
									fromAddress={this.state.fromAddress}
									fromAddressLoc={{ lat: this.state.fromAddressLat, lon: this.state.fromAddressLng }}
									stype={this.stype}
									deliveryId={deliveryId}
									uid={uid}
									calendar={calendar}
								/>
							) : (
								<CarBooking
									closePopup={this.props.closePopup}
									togglePopup={this.props.togglePopup}
									show={isShowBooking}
									hideModal={this.closeBooking}
									car={car}
									promoCode={promoCode}
									owner={this.props.owner}
									startDate={startDate}
									endDate={endDate}
									fromAddress={this.state.addressArray[0]}
									fromAddressLoc={{
										lat: this.state.locationArray[0].lat,
										lon: this.state.locationArray[0].lng,
									}}
									address={this.state.isCityTourMode ? [this.state.addressArray[0]] : this.state.addressArray}
									wdDistance={this.state.isCityTourMode ? 0 : this.state.wdDistance}
									wdLocations={
										this.state.isCityTourMode
											? this.state.wdLocations && this.state.wdLocations.split(",")[0]
											: this.state.wdLocations
									}
									wdDistanceBackOW={this.state.wdDistanceBackOW}
									wdOneWay={this.state.wdOneWay}
									stype={this.stype}
									isCityTourMode={this.state.isCityTourMode}
									isDeliveryByAddressCar={this.state.isDeliveryByAddressCar}
									locAddress={this.state.locAddress}
									deliveryId={deliveryId}
									directionsResponse={this.state.directionsResponse}
									uid={uid}
									insuranceBy={activeIns}
									calendar={calendar}
								/>
							)}
						</>
					)}
				</>
			);
		}

		return <div className="sidebar-detail">{content}</div>;
	}
}

function mapState(state) {
	return {
		appInit: state.appInit,
		session: state.session,
		carFinding: state.carFinding,
		carDetail: state.carDetail,
	};
}

BookingSideBar = connect(mapState)(BookingSideBar);
export default BookingSideBar;
